//English  提示：只需要翻译冒号:后面的英文即可。
export const language = {
    meassage:{
        leanMore:'もっと詳しく知る',
            skip:'スキップ',
            activate:'アクティベート',
            emailSend: 'Email sent!',
        },
    leftBanner: {
        liteFile: 'Lite File',
        logoSlogan: 'クラウド転送の第一選択肢',
        cloudEscription: 'MultCloud – クラウド間データ転送の頼れる選択肢',
        commonTools: '一般的なツール',
        cloudDrives: 'マイクラウド',
        onlineServices: 'マイオンラインサービス',
        switchTxt: 'MultCloud旧版に切り替える',
        taskList: 'タスクリスト',
        cloudTransfer: 'クラウド転送',
        cloudSync: 'クラウド同期',
        cloudBackup:'クラウドバックアップ',
        btLink: 'リモートアップロード',
        teamTransfer:'チーム転送',
        shares: '共有',
        emailTransfer: 'メール移行',
        instagramDownload: 'Instagramダウンローダー',
        videoDownload: 'ビデオダウンローダー',
        webDownload: 'ウェブ画像ダウンローダー',
        addCloud: 'Add Cloud',
        addEmail: 'Add Email',
        encryption: '暗号化',
        edit: '再追加',
        remove: '削除',
        createTask: 'タスクの作成',
        createTaskText: 'ここで最も一般的なタスクを作成できます。',
        gotIt: '手に入れる',
        bigWriteEncrypt: '暗号化',
        encryptionText: 'ここでクラウドファイルの暗号化を設定できます。',
        addCloudText: 'ここをクリックして、クラウドドライブとメールをMultCloudに接続します。',
        inviteFriends: '友達を招待',
        switchTip:'MultCloud旧版に切り替える',
        switchTipDes:'ここでMultCloud旧版に切り替えることができます。',
        new: 'New',
    },
    common: {
        addCloud: 'クラウドを追加',
        addEmail: 'メールを追加',
    options: 'オプション',
        schedule: 'スケジュール',
        ok: 'はい',
        save: '保存',
        add: '追加',
        upgradeNow: '今すぐアップグレード',
        from: '同期元',
        to: '同期先',
        result: '結果',
        fileProcess: '処理されるファイル',
        transferFiles:'ファイル',
        dataProcess: '処理されたデータ',
        startTime: '開始時間',
        currentRate: '現在のレート',
        endTime: '終了時間',
        timeRemaining: '残り時間',
        averageRate: '平均レート',
        averageRateSpecial: '平均レート',
        viewFailed: 'クリックして失敗したファイルを表示',
        fileSuccess: 'すべてのファイルの転送が成功しました。',
        size: 'サイズ',
        executedTimes: '実行回数',
        sourceDir: 'ソースディレクトリ',
        cause: '原因',
        retry: '再試行',
        retryMin: '再試行',
        clean: '削除',
        properties: 'プロパティ',
        copy: 'コピー',
        move: '移動',
        multiSelect: '複数選択',
        close: '閉じる',
        copyTo: 'コピー先',
        tranTo: '転送先',
        syncWith: '～と同期',
        backupTo: 'バックアップ先',
        download: 'ダウンロード',
        delete: '削除',
        more: '移動',
        preview: 'プレビュー',
        share: '共有',
        shareWith: 'MultCloudと共有',
        shareTransfer: '転送を作成',
        encrypt: '暗号化',
        encryptFile: 'ファイルのみを暗号化',
        encryptFileName: 'ファイルと名前を暗号化',
        decrypt: '復号化',
        decryptFile: 'ファイルのみを復号化',
        decryptFileName: 'ファイルと名前を復号化',
        onedriveBusinessContentNote: '注意',
        oneDrive4BusinessContent: '管理者の方であり、ユーザーにMicrosoft 365のライセンスを割り当てたが、MultCloud経由でユーザーのフォルダにアクセスしようとすると「アクセスが拒否されました」というエラーが表示される場合は、以下の手順をお試しください：',
        oneDrive4BusinessTips1: `「<a href="https://admin.microsoft.com/" target="_blank" class='add-onedrivebuiness-link'>管理者</a>」に移動します。「ユーザー」＞「アクティブユーザー」タブを選択します。＞「製品ライセンスの管理」オプションを選択します。`,
        oneDrive4BusinessTips2: '「OneDrive」タブに移動し、「ファイルのリンクを作成」をクリックします。その後、MultCloudに戻り、アカウントに再度アクセスしてみます。',
        oneDrive4BusinessStep1: '手順1',
        oneDrive4BusinessStep2: '手順2',
        upStep: '前へ',
        nextStep: '次へ',
        complete: '完了',
        cut: '切り取り',
        viewDetails: '詳細',
        toOfficialSite: '公式サイト',
        btLinkTask: 'リモートタスク',
        fileName: 'ファイル名',
        itemsSelected: '選択したアイテム',
        dateModified: '変更日',
        rename: '名前を変更',
        paste: '貼り付け',
        btLink: 'リモートアップロード',
        load: '読み込み中',
        status: '状態',
        operate: '作業',
        failure: 'エラー',
        link: 'リンク',
        cleanList: 'リストを削除',
        type: '入力',
        account: 'アカウント',
        name: '名前',
        selectFailedFile: '失敗したファイルを選択してください。',
        transferring: '転送中',
        newPassword: '新しいパスワード',
        confirmPassword: 'パスワードを確認',
        done: '完了',
        no: 'いいえ',
        yes: 'はい',
        attention: '注意',
        cancel: 'キャンセル',
        unsubscribe: '解除する',
        reactivate: '再活性化する',
        sureCleanAll: '完了済みのタスクをすべて削除してもよろしいでしょうか？',
        failedFiles: '失敗したファイル',
        minTo: '同期先',
        retryAll: 'すべて再試行',
        viewProgress: '進行状況を表示',
        taskNotRun: 'このタスクは実行されていません。',
        success: '成功',
        failure: '失敗',
        canceled: 'キャンセル',
        patial: '部分的な成功',
        syncDetails: '同期の詳細',
        width: '幅',
        sync: '同期',
        targetCloud: 'ターゲットクラウドストレージ',
        running: '実行中',
        preparing: '準備中',
        waiting: '待っている',
        target: '目標',
        noVip: 'これで、最大2つのファイルを同時に転送できます。プレミアムサービスにアップグレードして、最大10つのファイルを同時に転送することができます！',
        vipThanks: 'ご購読いただきありがとうございます。これで、最大10個のファイルを同時に転送できます。',
        emailAccount: 'メールアカウント',
        with: '同期先',
        syncing: '同期中…',
        selectAll: 'すべて選択',
        date: '日付',
        failed: '失敗しました！',
        skip: 'スキップ',
        replace: '交換',
        ready: '準備',
        connecting: '接続中',
        account: 'アカウント',
        selectNull: 'ターゲットディレクトリを選択してください。',
        selectOther: 'ファイルを貼り付けるためにこのディレクトリを選択することはできません。サブディレクトリまたは他のディレクトリを選択できます。',
        //2020-10-26-ljm新增
        filterHolder:'拡張子（例えば、mp4）を入力',
        countFiles:'ファイルのカウント',
        //2020-8-18-xth新增
        editShare: '共有設定',
        toSource: 'ソースへ',
        copyLink: 'リンクをコピー',
        toShare: '共有へ',
        report: 'リポート',
        expand: '展開',
        shrink: '折りたたみ',
          //2020-12-2-ljm新增
        upgradeMulti:'マルチスレッドにアップグレード',
        team: "チームファイル",
        loadData:'データを読み込んでいます。しばらくお待ちください',
        getAccountInfo:'アカウント情報を取得できません。再ログインして、もう一度お試しください。',
        loadingData:'データ読み込み中...',
        failedEmptyTip: 'ファイルの読み込みに失敗しました。<a href="mailto:support@multcloud.com">support@multcloud.com</a>までお問い合わせください。',
        runNow:'今すぐ実行',
        emailFilter: 'メールフィルタ',
        me: "私",
        reset: "リセット",
        apply: "適用",
        failureReason: '失敗理由',
        countingFilesTip: '計算中({num}ファイル)',
        taskName: 'タスク名',
        frequency: '頻度：',
        canceling: 'キャンセル中...',
    },
    rightTopBanner: {
        navTransfer: 'クラウド間転送',
        navInstagram: 'Instagramダウンローダー',
        navVideo: 'ビデオダウンローダー',
        navWeb: 'ウェブ画像ダウンローダー',
        traffic: '転送量',
        upgrade: 'アップグレード',
        settings: '設定',
        changePassword: 'パスワードの変更',
        changeName: '名前変更',
        bindEmail: 'メールバインド',
        deleteAccount: 'アカウントの削除',
        language: '言語',
        help: 'ヘルプ',
        notifications: '通知',
        notification: '通知',
        subAccounts: 'サブアカウント',
        logout: 'ログアウト',
        tutorials: 'チュートリアル',
        contact: 'お問合せ',
        limitsClouds: 'クラウドの制限',
        faq: 'FAQ',
        purTraffic: 'データ転送量を購入',
        unlimitedPlan: '無制限プラン',
        monthlyUnlimitedPlan: '月額無制限プラン',
        rememberOriginal: '元のユーザー名を覚えておいてください：',
        andPassword: 'とパスワード',
        bindEmailOpen: 'セキュリティと利便性のために、<span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen">メールアドレスをバインドし、デフォルトのパスワードを変更する</span>ことをお勧めします。',
        lifeSwitchTip: '無期限無制限サービスでファイルをクラウド間で制限なし転送できます。',
        lifeTimePlan: '無期限無制限',
        browserPrompt:'ユーザー体験を向上させるためにGoogle Chromeの使用をお勧めします。',
        unlimited:'無制限',
        lifeTimeNotice:'すでにMultCloud無期限無制限プランのユーザーです。',
        subAccount:"サブアカウント",
        bindMailTips:"クラウドファイル転送のロックを解除し、MultCloudを最大限に活用するために、Eメールをバインドしてください。",
        bind:"バインド",
    },
    popup: {
        userStarPopup: {
            starDesc: "これまでの使用状況はどうですか？",
            ok: "OK",
            thankYou: "ありがとうございます！",
            thankYouDesc: "よろしければ、少し時間を割いて、当社の製品を使用した実際の体験を共有していただき、MultCloudをさらに改善するという当社のチームモチベーションを維持するのに役立ちます。",
            reviewStart: "",
            reviewEnd: "で良い評価をお願いします。",
            feedbackTitle: "どうすれば改善できるでしょうか",
            feedbackDesc: "MultCloudに関する問題のフィードバックは真摯に受け止めます。",
            feedbackBtn: "提出する",
            feedbackYes: "フィードバックありがとうございます。",
            feedbackNo: "フィードバックをご入力ください。",
        },
        addCloudPopup: {
            endpointOptional:'エンドポイント(オプション)',
            //2020.09.23 添加NAS云盘
            addNas: 'NASの追加',
            addNasFtpDes: `FTP経由でNASを接続します。NASのFTPの設定方法を知りたい場合、<a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>ここをクリック</a>してください。`,
            addNasWebDes: `WebDAV経由でNASを接続します。NASのWebDAVの設定方法を知りたい場合、<a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>ここをクリック</a>してください。`,
            bucketName: 'バケット名',
            accessKeyId: 'アクセスキーID',
            idriveKeyId: 'Access Key ID',
            secretAccessKey: 'シークレットアクセスキー',
            idriveSecretAccessKey: 'Secret Access Key',
            endpoint: 'Endpoint',
            displayName: '表示名',
            addFtp: 'FTPの追加',
            addFtpDes: 'FTPを接続するためにMultCloudは認証情報を入力するよう求めます。',
            egnyteTip: `ヒント：キーとシークレットを取得するには、Egnyte API管理IDが必要です。お持ちでない場合は、<a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>こちらから登録</a>できます。`,
            icedriveTip: '注：',
            icedriveTip1: '1. Icedriveプレミアムアカウントのみサポート。',
            icedriveTip2:`2. Icedriveユーザー名 -> 2FA＆アクセス -> WebDAV -> 有効化 -> キーの表示をクリックします。アクセスキーはパスワードです。`,
            iCloudPhotosTip: 'ヒント：',
            iCloudPhotosTip1: '1. iCloud写真をMultCloudに接続する前に、「Web上のiCloudデータにアクセス」がオンになっていることを確認してください。',
            iCloudPhotosTip1Q: `iCloudデータへのWebアクセスを管理する方法：<br><br>iPhoneやiPadの場合<br>1. 設定アプリを開きます。<br>2. 名前をタップして、iCloudをタップします。<br><br>3. 「Web上のiCloudデータにアクセス」をタップして、オン／オフを切り替えます。<br>
            <br>Macの場合<br>1. Appleメニュー＞「システム設定」の順に選択します。<br>2. 名前をクリックして、iCloudをクリックします。<br>3. 「Web上のiCloudデータにアクセス」をクリックして、オン／オフを切り替えます。`,
            iCloudPhotosTip2: '2. iCloud写真は、jfif、pjpeg、jpeg、pjp、jpg、HEICの画像形式のみをサポートします。',
            server: 'サーバー',
            protocol: 'プロトコル',
            port: 'ポート',
            passive: 'パッシブモード',
            passphrase: 'パスフレーズ',
            explanation: 'FTPに接続するために、ftp://プレフィックスを使用するか、プレフィックスを省略する必要があります。FTPのポート番号は デフォルト値「21」ではない場合、以下のような形式でポート番号を指定してください：ftp://ftp.myhost.com:21',
            userName: 'ユーザー名',
            passWord: 'パスワード',
            advanced: 'アドバンスド',
            commFTP: '一般的なFTP',
            transMode: '転送モード',
            encoding: '符号化',
            path: 'パス（オプション）',
            cloudName: 'クラウド名',
            cloudService: 'クラウドサービス',
            addedTime: '追加日時',
            userName: 'ユーザー名',
            usedSpace: '使用領域',
            totalSpace: '容量',
            iCloudUsedSpace: 'iCloud Photos使用容量',
            iCloudDriveUsedSpace: 'iCloud Drive使用容量',
            iCloudTotalSpace: 'iCloud総容量',
            iCloudDriveTotalSpace: 'iCloud総容量',
            removeContent: ' 一部のクラウド転送はこのクラウドに基づきます。削除してもよろしいですか？',
            google_driveTips: 'Googleドライブからファイル／フォルダを転送する場合、同じディレクトリに同じ名前のファイルがないことを確認してください。',
            baiDuTips: 'ファイルは「全部文件/我的应用数据/MultCloud」ディレクトリにのみアップロードまたは転送できる',
            mySQLQuestion: 'MySQLサーバーのIPアドレスをフィールドサーバで入力します。デフォルトのポート3306が表示されるか、カスタムポートを入力します。',
            webDavQuestion: `安全なSSL接続を使用し、ホストに「https://」接頭辞を追加するか、何もせずにデフォルトのポート443が表示されます。それ以外の場合、接頭辞は「http://」であり、デフォルトのポートは80です.
            例えば、 https: //dav.box.com/dav `,
            egnyteQuestion: `Engnyteにログインし、アドレスバーでドメインを見つけ、https://aomeitech.egnyte.com/という形式でドメインを入力してください。`,
            ownCloudQuestion: '安全なSSL接続を使用し、ホストに「https://」接頭辞を追加するか、何もせずにデフォルトのポート443が表示されます。それ以外の場合、接頭辞は「http://」であり、デフォルトのポートは80です。',
            amazonQuestion: `<a href="https://www.multcloud.com/jp/tutorials/s3-key.html" target="_blank" class='
            add-cloud-link'>Amazon S3アクセスキーIDを取得する方法を学習</a>という記事をご参照ください。`,
            boxTips: 'Boxは、2GBを超える単一ファイルの転送をサポートしていません。',
            google_drive_sharedWithMeTips:'Shared With Me driveのフォルダにファイルを転送するときは、「アップロード権限」が許可されていることを確認してください',
                       gSuiteSharedDriveTips:'Shared Driveのフォルダにファイルを転送するときは、「アップロード権限」が許可されていることを確認してください',
            webDavTips: `1.ファイル操作の前に読み取り/書き込み権限があることを確認してください。そうしないと、MultCloudがファイルをWebDavに転送できない場合があります。
            2. 作業需要のスペースが十分であることを確認してください。 サイズを一時的にはっきり認めることができません。`,
            aDriveTips: '個人プレミアムおよびビジネスアカウントはサポートされていますが、個人ベーシックアカウントはサポートされていません。',
            yandexTips: `1.作業需要のスペースが十分であることを確認してください。サイズを一時的にはっきり認めることができません。
                         2.アプリのパスワードを有効にしている場合は、上のパスワードバーにアプリのパスワードを入力してください。`,
            googlePhotosTips: `1.「写真」ディレクトリには、画像、動画、及びその他のメディアファイルを保存でき、ディレクトリは保存できません。
            2.「 アルバム」 ディレクトリには、 アルバムディレクトリをのみ保存でき、 メディアファイルは保存できません。
            3.「 共有」 ディレクトリには、 あなたから共有したアルバム、 または他人から共有されたアルバムが含まれます。
            4. Googleフォトでは、 画像、 動画、 及びその他のメディアファイルのアップロードのみがサポートされています。 また、 MultCloudのアップロード機能を使用する場合、 MultCloudによって作成または共有されたアルバムディレクトリにのみファイルをアップロードできます。
            5. MultCloudのソース共有機能を使用すると、 MultCloudで作成されたアルバムのみを共有できます。
            6. 無題のアルバムは「 無題」 として表示されます。
            7. 現在、 ダウンロード機能は使用可能ですが、 元のファイルのダウンロードはサポートされていません。
            8. 切り取り、 削除、 名前変更の機能はサポートされていません。 また、 これらの操作に依存する機能は使用できません。`,
            googlePhotosV2Tips: `1.「写真」ディレクトリには、画像、動画、及びその他のメディアファイルを保存でき、ディレクトリは保存できません。
            2.「 アルバム」 ディレクトリには、 アルバムディレクトリをのみ保存でき、 メディアファイルは保存できません。`,
            evernoteTips: `1. APIレート制限。<a href='https: //dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'>詳しく見る>> </a>
            2. Evernoteのシステム制限とは？ <a href='https://help.evernote.com/hc/en-us/articles/209005247-What-are-the-system-limits-of-Evernote-' target = "_blank" class='add-cloud-link'> 詳しく見る >> </a>
            3. 50 MB以下のファイルしかノートにアップロードできません。
            4. ノートコンテンツ(.enex) ファイルを再命名または削除できません。
            5. ノートをノートブックだけにコピーできます。`,
            flickrTips: `1. 写真またはビデオだけをFlickrに転送できます。
            2. フォルダがAlbumsディレクトリだけに転送されます。 Albumsディレクトリの下にサブディレクトリがあってはいけません。
            3. 作成されたMy PhotoStreamまたはAlbumsディレクトリだけにファイルが転送されます。
            4. My PhotoStreamディレクトリで全てのファイルが見つかります。
            5. Albumsディレクトリ内の全てのファイルはMy PhotoStreamディレクトリを参照することです。`,
            mediafireTips: '空ファイルのアップロードとダウンロードがサポートされません。多くのファイルを含むフォルダを開くには多くの時間がかかります。',

            mySQLTips: `1. 我々のIPアドレス209.126.%からあなたのデータベースにアクセスできる必要があります。データベースまたはホストインタフェースを介して新規ユーザーを作成できます。MySQLコマンドは次の通りです： <span class = 'add-mysql-link' > GRANT SHOW DATABASES,SELECT,LOCK TABLES, RELOAD ON * .*TO username @ '209.126.%' IDENTIFIED BY 'password' </span>;
            2. あなたのデータベースにアクセスできるために、 サーバで我々のIPアドレスのファイアウォールルールとポート（ デフォルトのポート番号は3306） を追加する必要があります。`,
            hubiCTips: `1. hubiCアカウントを一度だけ追加できます。
            2. ファイルまたはフォルダを再命名、 切り取りできません。
            3. 多くのファイルを含むフォルダの削除は遅くなるかもしれません。
            4. hubiCは5GB以上の単一ファイルの転送をサポートしません。
            5. ファイル名は248文字以下、 フォルダ名は256文字以下でなければなりません。`,

            gSuiteUpTips: `G Suiteの管理者しかG SuiteをMultCloudと接続できません。G SuiteをMultCloudと接続するにはまず G Suite Marketplace アプリから<a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud?hl=en' target="_blank" class='add-cloud-link'>「Cloud Transfer - MultCloud」</a>をインストールする必要があります。`,

            gSuiteTips: `1.<a href="https://support.google.com/a/answer/2405986?hl=ja" target="_blank" class='add-cloud-link'>G Suiteの管理者</a>になる必要があります。
            2. 管理者アカウントの確認方法は？ まず < a href = 'https://support.google.com/a/answer/2406043' target = "_blank" class = 'add-cloud-link' > https: //support.google.com/a/answer/2406043</a>リンクを参照します。そしてリンクからG Suiteアカウントにログインします。最後「カスタムロールを作成する」で結果を見つけます。
            3. このクラウドストレージを追加する前に < a href = 'https://gsuite.google.com/marketplace?hl=jp' target = "_blank" class = 'add-cloud-link' > G Suite Marketplace アプリ < /a>から「Cloud Transfer - MultCloud」をインストールする必要があります。<a href='https:/ / admin.google.com / ' target="_blank" class='add-cloud-link '>セットアップ</a>が正しいことを確認：オン状態になり、データへのアクセスが許可されます。`,
            hiDriveTips: `1.ファイルを操作する前に、WebDAVプロトコルが有効化されており、読み書きの権限があるアカウントをご用意ください。そうでない場合、MultCloudはHiDriveにファイルを転送できない可能性があります。
            2. 操作のために十分な空き容量を確保してください。 今我々はそのサイズを検知できません。`,
            backblazeTips: `1.バケット名は6文字以上にする必要があります。
            2. 新しいアプリケーションキーを作成すると、 古いキーは無効になります。
            3. ファイル名は「 / 」で始まるまたは終わることはできません。 また「 //」を含めることもできません。`,
            WEBDETips: `1.ファイル操作の前に読み取り/書き込み権限を持つことを確認してください。さもないと、MultCloudはファイルをWeb.Deに転送できません。
            2. 操作のために十分な空き容量を確保してください。 今我々はそのサイズを検知できません。 `,
            alfrescoTips: '無料のAlfrescoアカウントで、10GBのストレージ容量が使えます。1つのファイルの最大容量は50MBになります。',
            cloudMeTips: `1.ファイル操作の前に読み取り/書き込み権限を持つことを確認してください。さもないと、MultCloudはファイルをCloudMeに転送できません。
            2. 操作のために十分な空き容量を確保してください。 今我々はそのサイズを検知できません。`,
            myDriveTips: `操作のために十分な空き容量を確保してください。今我々はそのサイズを検知できません。`,
            cubbyTips: `1.ファイル操作の前に読み取り/書き込み権限を持つことを確認してください。さもないと、MultCloudはファイルをCubbyに転送できません。
            2. 操作のために十分な空き容量を確保してください。 今我々はそのサイズを検知できません。`,
            cloudType: 'クラウドの種類',
            notificationTip: '最新のMultCloudをご利用いただきありがとうございます。弊社のメールは「<a href="mailto:support@multcloud.com">support@multcloud.com</a>」で、もしご不明な点などがありましたら、遠慮なくご質問ください。',

            notAbleAccess: 'Googleフォトにアクセスできない問題が解決しました。',

            problemNotAccess: 'Googleフォトにアクセスできない問題が修正されました。それでもGoogleフォトにアクセスできない場合は、MultCloudに再度追加してください。',

            noPrompt: '次回プロンプトを表示しない',
            addFeatures: '以下のいくつかの新しい追加機能：',
            version: 'バージョン：',
            applicationKey: 'アプリケーションキー',
            keyID: 'キーID',
            privateKey: '認証用の秘密鍵ファイル（オプション）',
            FTPTips:`1. 操作前に読み書き許可を持つことを確認してください。さもないとMultCloudはFTPにファイルを転送できないかもしれません。
            2. FTPの容量を一時的に認識できないため、十分な空き容量を確保してください。
            3. FTPにアクセスできない場合、209.126.103.1/19と207.38.89.1/24をファイアウォールのホワイトリストに追加してください。`,
            specialDropBox:`Dropbox Businessの管理者であり、組織のすべてのアカウントにアクセスしたい場合は、「組織にアクセス」をクリックしてください。`,
            specialDropBoxBottom:`パーソナルクラウドへのアクセスをご希望の場合は、「パーソナルクラウドにアクセス」をクリックしてください。`,
            accessOrganization:'組織にアクセス',
            accessPersonalCloud:'パーソナルクラウドにアクセス',
            specialBoxBusiness:`box for Businessの管理者であり、組織のすべてのアカウントにアクセスしたい場合は、「組織にアクセス」をクリックしてください。`,
            specialgSuite:`<a href='https://support.google.com/a/answer/2405986?hl=ja' target="_blank" class ='add-cloud-link'>Google Workspaceの管理者</a>であり、組織のすべてのアカウントにアクセスしたい場合は、まずG Suite Marketplaceアプリ---「<a href="https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391?hl=ja" target="_blank" class='add-cloud-link'>クラウド転送 – MultCloud</a>」を「ドメインインストール」してください。そして、「組織にアクセス」をクリックします。`,
            specialOnedrive:`OneDrive for Businessの管理者であり、組織のすべてのアカウントにアクセスしたい場合は、「組織にアクセス」をクリックしてください。`,
            iCloudPhotosTips:'MultCloudは現在、Eメール以外のApple IDをサポートしていません。',
            appleId: 'Apple ID',
        addICloudPhotos: 'iCloud 写真を追加',
        addICloudDrive: 'iCloud Driveを追加',
        fourShared: `注意：4sharedの認証は<span style="color: red"> 2時間</span>有効期限が切れたら、4sharedを再追加し、手動でタスクを実行してください。`,
        fourSharedTips: `注意：4sharedの認証は2時間有効です。有効期限が切れたら、4sharedを再追加し、手動でタスクを実行してください。`,
        },
        cloudExploerPopup: {
            googlePhotosV2Tips: 'Googleフォトに関するヒント',
            googlePhotosV2TipsDesc: 'Googleは2025年5月7日付けでGoogle Photos APIを更新しました。これらの変更に対応するため、以下の更新を実施する必要があります：',
            googlePhotosV2Tips1: '「アルバム」フォルダには、MultCloudで作成したアルバムのみが表示されるようになります。',
            googlePhotosV2Tips2: '「写真」フォルダには、MultCloud経由でアップロードした画像のみが表示されるようになります。',
            googlePhotosV2Tips3: 'Googleフォトから他のクラウドサービスへ画像を転送する場合は、「さらに写真を追加」ボタンをクリックし、転送したい画像へのアクセス権をMultCloudに付与してください。',
            googlePhotosV2Tips4: '他のクラウドサービスからGoogleフォトに画像を転送する場合、「アルバム 」フォルダに転送できるのはフォルダのみで、「写真 」フォルダに転送できるのは個々の画像のみであることにご注意ください。',
            googlePhotosV2TipsShow: '今後このメッセージを表示しない',
            googlePhotosV2AddMore: 'さらに写真を追加',
            googlePhotosV2AddMoreTips: 'MultCloudに追加したい画像をここで選択してください。',
            googlePhotosV2FolderName: 'フォルダ名',
            googlePhotosV2FolderNameInput: '画像を保存するフォルダの名前を入力します',
            googlePhotosV2NotSelect: 'まだ写真が追加されていません。「さらに写真を追加」をクリックしてMultCloudに画像を追加してください',
            googlePhotosV2SelectAlbums: '「アルバム」にはフォルダのみ保存可能',
            googlePhotosV2SelectAlbum: 'このフォルダには画像と動画のみ保存可能',
            googlePhotosV2SelectPhotos: '「写真」には画像と動画のみ保存可能',
            googlePhotosV2SelectSession: 'このフォルダは転送先として選択できません。「アルバム」または「写真」フォルダを選択してください。',
            deleteContentEver: '選択したアイテムを完全に削除してもよろしいですか?<br>一度削除すると、ゴミ箱から復元することはできません。',
            deleteContent: '選択した項目を削除してもよろしいですか？',
            detailedProgress: '進捗状況の詳細',
            highSpeed: '高速検索は以下のクラウドに適用される',
            takeMoreTime: '以下のクラウドにかかる時間より多い',
            enterKeyWord: 'キーワードを入力してください',
            highSpeedSearch: '高速検索',
            normalSearch: '通常検索',
            shareWithOthers: '他の人と共有',
            inviteByEmail: 'メールで友達を招待',
            pleaseEnterEmail: 'コンマで複数のメールアドレスを区切って入力してください',
            addMessage: 'メッセージの追加（オプション）',
            shareTo: '共有先',
            noLink: 'リンクはまだ作成されていない',
            createShare: '共有の作成',
            cancelAllTask: 'すべてのタスクをキャンセルしてもよろしいですか?',
            //2020/8/7-xth
            shareEmailTitle: 'メールでリンクを送る',
            shareNotSupportSource: 'このクラウドはこの機能をサポートしません。ほかの共有オプションを選択してください。',
            shareSendEmail: 'メールを送信',
            generateLinkSuccess: '共有リンクが作成された',
            generateLinkFail: 'Ｎ共有リンクの作成に失敗した',
            emailSentSuccessful: 'メールが送信された',
            emailSentNull: 'メールアドレスを入力してください',
            emailSentNotice: '正しいメールアドレスを入力してください',
            linkCopySuccessful: 'リンクがコピーされた',
            sharePrivateLink: 'プライベート共有リンク： ',
            sharePrivatePassword: '  ビューパスワード： ',
            cancelMyShareTask: '共有をキャンセルしてもよろしいですか？キャンセル後、このリンクは所有者にとって無効となります。',
            cancelMyShareOk: 'はい',
            cancelMyShareNot: 'いいえ',
            emailArrayToLong50: '50通のメールを同時に送信できます。',
            shareOnEmail: 'Eメールでリンクを送信',
            shareOnFacebook: 'Facebookで共有',
            shareOnTwitter: 'Twitterで共有',
            shareOnTumblr: 'Tumblrで共有',
            shareOnPinterest: 'Pinterestで共有',
            shareOnLinkedIn: 'LinkedInで共有',
            ceateShareError: '共有を作成できません。ネットワークの設定を確認してください。'
        },
        cloudTransferPopup: {
            pleaSelect: '選択してください',
            schedule: 'スケジュール',
            checkScheduled: 'このタスクの「スケジュール」ボックスをオンにして、スケジュールエディターをアクティブにしてください。',
            addValidCloud: '有効なクラウドドライブを追加する必要があります。',
            //2020-10-26-ljm增加
            cleanList:'リストを削除'

        },
        personalCenter: {
            changePassword: 'パスワードの変更',
            changeName: '名前変更',
            deleteAccount: 'アカウントの削除',
            enterPassWord: 'パスワードを入力してください',
            note: '使用をやめる理由、教えてもらえますか？不具合やバグの修正に最善を尽くします。',
            sureDeleteAccount: 'このアカウントを削除してもよろしいですか？',
            unsubscribe: 'アカウントを削除する前にMultCloudの購読を中止してください。',
            bindEmail: 'メールをバインド',
            pleaseSwitch: 'ファイルの復号化にMultCloud旧版に切り替えてください。',
            switchOld: 'MultCloud旧版に切り替える',
            pleaseUnsubscribe: 'まずMultCloud旧版に切り替えてプレミアムサービスを解約してください。',
            deletePremium: 'プレミアムアカウントを削除してもよろしいですか？削除すると、二度と取り戻すことができません。',

        },
        remoteTaskPopup: {
            addLinkTask: 'リンクタスクの追加',
            validLink: '有効なリンクを入力してください',
            saveCloud: 'クラウドに保存',
            //2020-10-26-ljm增加
            linkSupported:'URLリンクをサポート',
            parseFail:'解析に失敗',
			inadmissibleRequest:'リクエストがサポートされていない',
			createBtTask: 'BTタスクを作成',
			emptySource: 'リンクを入力するかトレントファイルをアップロードしてください',
			validTorrent: '無効なトレントファイル',
			addTorrent: 'トレントを追加',
			tip: 'ファイルを保存するためのクラウドを選択',
			torrentSelected:'名前 ({num}/{all})',
			urlLinkSupported:'リンクをコピーしてここに貼り付けます。http、https、magnetリンクがサポートされます.\n注：MultCloudを使用してアクセスが許可されていないか、著作権を侵害している資料をダウンロードまたはアップロードしないでください',
			torrentStore:'トレントファイルを保存するクラウドを選んでください',
			downloadLink:'ダウンロードリンクを入力してください',
			cancelTask:'タスクをキャンセル',
			cancelTaskContent:'タスクをキャンセルしてもよろしいでしょうか？',
			parseTaskRunning:'MultCloudはすでに解析プロセスを実行しています。「リモートアップロード」に移動して確認してください'
        },
        taskListPopup: {
            deleteTask: 'タスクの削除',
            pleaseSelect: '削除前にデータを選択してください。',
            sureDeleteTask: 'タスクを削除してもよろしいですか？',
            deleteSingleTask: 'このタスクを削除してもよろしいですか？',
            viewLogs: 'ログ表示',
            selectCloud: 'ファイルを保存するクラウドを選択してください。'
        },
        upgradeAccountPopup: {
            commonTitle: '5つのクラウド間タスクを並行して実行',
        commonDes: 'サブスクライバーにアップグレードしてください。5つのクラウド間タスクを並行して実行できるようになります。',
        upgradeAccount: 'アカウントをアップグレード',
            upgradeHeadTitle:'5つのリンクまたはトレントを同時に処理',
			upgradeHeadContent:"無料ユーザーは一度に1つだけのリンクまたはトレントを処理できますが、有料会員にアップグレードしたら、5つのリンクまたはトレントを同時に処理できます",
            currentPlan: '現在の計画',
            insufficientTraffic: '不十分なクラウド間トラフィック',
            insufficientTrafficDes: '今月のすべての無料データトラフィックを消費しました。トラフィックを増やすには、プレミアムバージョンにアップグレードしてください。',
            filter: 'ファイル転送/フィルター同期',
            filterDes: 'ファイル転送/フィルター同期をアクティブにするには、プレミアムバージョンにアップグレードしてください。',
            offlineFree: '一度に1つのリンクまたはトレントを処理',
            offlinePremium: '5つのリンクまたはトレントを同時に処理',
            modes: '高度な同期モード',
            modesDes: 'サブスクライバーには、双方向同期と7つの一方向同期カスタムオプションがあります。増分バックアップ同期がサポートされています。',
            doubleRealTime:'2つのリアルタイム同期実行可能',
            doubleRealTimeSyncDes:'2つのリアルタイム同期タスクを同時に実行するにはサブスクライブしてください。',
            doubledSync: '2つの通常同期実行可能',
            doubleSyncDes: '2つの通常同期タスクを同時に実行するにはサブスクライブしてください。',
            realTimeSyncing:'2つのリアルタイム同期実行可能',
            norMalSyncing:'2つの通常同期実行可能',
            free: '無料',
            premium: 'プレミアム',
            monthTraffic: '5GBトラフィック/月',
            syncMode: '2つの同期モード',
            scheduled: 'スケジュールされた転送/同期/バックアップ',
            scheduledDes: 'スケジュール機能を有効にするには、プレミアムバージョンにアップグレードしてください。',
            moreTraffic: '必要な、より多くのデータトラフィック',
            moreSyncModes: '8つの同期モード',
            transferSpeed: '5倍の転送速度',
            doubleSync: '二重同期',
            transferServer: 'VIP転送サーバー',
            customerSupport: 'VIPカスタマーサポート',
            syncSupported: '双方向同期、7つの一方向同期カスタムオプションがあります。ミラー同期がサポートされています。',
            greatlyIncreased: 'サブスクライバーの場合、2つではなく10個のスレッドがあるため、転送速度が大幅に向上します。',
            sameTime: 'サブスクライバーは、2つのリアルタイム同期タスクと2つの通常同期タスク（合計4つのタスク）を同時に実行できます。',
            normalSametime:'サブスクライバーは、2つの通常同期タスクを同時に実行できます。',
            automatically: 'ユーザー定義のファイル名または特定の拡張子を持つファイルを自動的に転送または同期するようにフィルターを設定します。',
            multipleSync: '複数の同期先',
            multipleSyncDes: '複数の同期先を選択できるように有料会員にアップグレードしてください。',
            freeDes:'無料のユーザーは、クラウドの間でデータを転送または同期するために、毎月合計30GBのデータ転送量を持っています。',
            task1: '1つのクラウド間タスクを同時に実行',
            task5: '5つのクラウド間タスクを並行して実行',
            emailTitle: 'メール変換がクォータ制限に達しました',
            emailDes: '無料ユーザーは毎月50件のメールを変換できますが、それだけでは足りないかもしれません。プレミアムにアップグレードすれば、無制限のメールを変換できます。',
            emailsConversions: '50件のメール変換/月',
            emailsUn: '無制限のメール変換',
        },
        remindBindEmail:{
            bindExe:'メールをバインドしてタスクを実行してください',
            onceBind:'メールをバインドすると、<span class="gift-flow">30GB</span>の追加のクラウドデータ転送量を取得できます。',
            bindEmail:'MultCloudの核心機能を有効にするには、メールをバインドしてください。',
            coreFeatures:'Multcloudの重要な機能',
            tourAccount:'ツアーアカウント',
            connectCloud:'クラウドサービスをMultCloudに接続します',
            viewCloud:'MultCloudですべてのクラウドファイルを表示します',
            uploadFile:'MultCloudでファイルをクラウドにアップロードします',
            downloadCloud:'MultCloudでクラウドファイルをダウンロードします',
            syncAndBackup:'クラウド間でファイルを同期およびバックアップします',
            transferFiles:'あるクラウドから別のクラウドにファイルを転送します',
            failed:'操作を実行できませんでした。しばらくしてからもう一度お試しください。'
        },
        salePagePopup:{
            sOffer:'毎月無制限向け特別オファー',
            timeLimited:'急いで、時間が迫っています！',
            Hours:'時',
            Minutes:'分',
            Seconds:'秒',
            monthPrice:'$19.9/月 ',
            dataTra:'無制限のデータトラフィック',
            subscribe:'今すぐ購読',
            features:'機能',
            freePlan:'無料プラン',
            bigSale:'期間限定大セール',
            discountsto:'最大割引',
            off:'25%オフ',
            premiumPlan:'プレミアムプラン',
            transmit:'データ転送量',
            dataTraffic:'クラウド間でファイルを転送、同期するためのデータ転送量。',
            originalPrice:'通常価格',
            nowOnly:'特別価格',
            getDiscount:'割引をゲット',
            moreData:'より多くのデータ転送量',
            unlimitedData:'データ転送量無制限',
            syncModes:'同期モード',
            syncModesDes:'有料会員は、双方向同期と一方向同期の7つのカスタムオプションを使用できます。ミラー同期がサポートされています。',
            scheduledTran:'定期転送',
            scheduledTranDes:'この機能により、クラウド間のタスクを定期的にまたは特定のタイミングで自動的にスケジュールできます。',
            transferSpeedDes:'有料会員のために２つのスレッドではなく、10個のスレッドなので転送速度はかなり上がっています。',
            fileEncryption:'ファイル暗号化',
            encryptFiles:'有料会員はクラウド上のファイルとアップロードしたファイルをオンラインで暗号化できます。',
            quarterly:'四半期ごと',
            yearly:'年額',
            monthGb:'毎月150GB',
            monthGbly:'毎月200GB',
            monthfourLy:'毎月400GB',
            unTr:'転送量無制限',
            nMonth:'/月額',
            tQuarter:'/四半期',
            eYear:'/年額',
            tOneTime:'ワンタイム',
             //2021-10-09
             premiumFeatures:'すべてのプレミアム機能と150GBのトラフィックを1ヶ月間提供！',
             unlimitedYear:'すべてのプレミアム機能と無制限のトラフィックを1年間提供！',
             unlimitedLiftime:'すべてのプレミアム機能と無制限のトラフィックを無期限に提供!',
        },
        properties: 'プロパティ',
        general: '全般',
        tips: 'ヒント',
        progress: '進捗状況',
        limits: 'クラウドの制限',
        detailed: '詳細',
        cancel: '全てキャンセル',
        simpleSync: 'シンプル同期',
        onewaySync: '一方向同期',
        twowaySync: '双方向同期',
        advancedSync: '高度な同期モード',
        mirrorSync: 'ミラー同期',
        moveSync: '移動同期',
        cmuSync: '累積同期',
        updateSync: '更新同期',
        increSync: '増分同期',
        fullSync: 'フル同期',
        simpleSyncTip: 'ソースディレクトリ下で追加、変更、削除されたファイルはターゲットディレクトリに複製されますが、ゲットディレクトリ下で追加、変更、削除されたファイルはソースディレクトリに複製されません。',
        mirrorSyncTip: 'ソースディレクトリとターゲットディレクトリの中身を常に同じ状態に保ちます（MultCloudはターゲットディレクトリ以下の余計なファイルをを削除します）。',
        moveSyncTip: '同期が完了すると、ソースディレクトリ内のファイルがすべて削除されます。',
        cmuSyncTip: 'ソースディレクトリにあるファイルを削除する場合、ターゲットディレクトリ下の同じファイルが削除されません。',
        updateSyncTip: 'ターゲットディレクトリ以下のファイルがすべて削除された後、ソースディレクトリ以下で追加、変更されたファイルはターゲットディレクトリに転送されます。',
        increSyncTip: 'ファイルを同期するたびに、ターゲットディレクトリの下にサブディレクトリが作成され、ソースディレクトリ下で追加、変更されたファイルはそこに転送されます。',
        fullSyncTip: 'ファイルを同期するたびに、ターゲットディレクトリの下にサブディレクトリが作成され、ソースディレクトリ下の全てのファイルはそこに転送されます。',
        twowaySyncTip: 'ソースディレクトリ下で追加、変更、削除されたファイルはターゲットディレクトリに複製されます。同様にゲットディレクトリ下で追加、変更、削除されたファイルはソースディレクトリに複製されます（つまり、ソースディレクトリとターゲットディレクトリ内のファイルがいつも同じになっています）。',
        syncModes: '同期モード',
        email: 'Eメール',
        filter: 'フィルタ',
        thread: 'スレッド',
        listThread: '走査したスレッド数',
        runThread: '実行されたスレッド数',
        sameName: '同名',
        filterInclude: '含まれる拡張子（例：png、doc、mp4）',
        filterExclude: '除外するファイル名（例：target、dist、build）',  
        newFilterTag: '新しいタグ',
        createTaskStatus: '作成済み',
        pendingTaskStatus: '待機中',
        runningTaskStatus: '実行中',
        cancelledTaskStatus: 'キャンセル済み',
        completedTaskStatus: '成功',
        failedTaskStatus: '失敗',
        warnTaskStatus: '警告',
        errorTaskStatus: 'エラー',
        warning: '警告',
        logs: 'ログ',
        once: '一度',
        daily: '毎日',
        weekly: '毎週',
        monthly: '毎月',
        onlyOnce: '一回だけ実行：',
        everyDay: '一日一度実行：',
        everyWeek: '曜日を選択：',
        at: '時刻を設定：',
        sunday: '日曜日',
        monday: '月曜日',
        tuesday: '火曜日',
        wednesday: '水曜日',
        thursday: '木曜日',
        friday: '金曜日',
        saturday: '土曜日',
        runAt: '時刻を設定：',
        lastDay: '最終日',
        chooseAction: 'ターゲットファイルが既に存在する場合、操作を選択してください：',
        optionsPrompt: 'ソースクラウドにあるファイルのファイル名にターゲットクラウドによって許可されていない特殊文字が含まれている場合、転送中にそのファイル名が自動的に変更され、ターゲットクラウドのルートディレクトリにlog.htmlというファイルが作成されます。',
        sourceNewer: 'ソースがより新しい場合、上書きします。',
        diffSize: 'サイズが異なる場合、上書きします。',
        sourceAll: 'サイズが異なる場合またはソースがより新しい場合、上書きします。',
        skipFile: 'ファイルをスキップします。',
        skipEmail: 'メールをスキップします。',
        overWrite: '常に上書きします。',
        rename: '再命名します。',
        overWriteSourceNewer: 'ソースメールに更新がある場合は上書きします。',
        deleteAllSource: '転送が完了すると、全てのソースファイルを削除します。',
        keepFileDate: 'ファイルの更新日時を維持します（Dropbox、Google ドライブ、G Suite）。',
        automaRename: '自動的に特殊文字を含むファイルを再命名し、スクリプトファイルを作成します。',
        sendEmail: 'このタスクが完了すると、メール通知を送信します。',
        sendMessage: 'テストメッセージを送信',
        ignoreFiles: 'この拡張子を持つファイルを無視',
        includeFiles: 'この拡張子を持つファイルを包含',
        selectSync: '同期モードを選択：',
        tipsFor: 'ヒント',
        allTasks: '全てのタスク',
        successful: '成功',
        unfinished: '未完成',
        transferDetails: '転送の詳細',
        redit: '再編集',
        publicShare: '公開共有',
        publicTip: 'ヒント：リンクへアクセスすれば誰でもファイルを閲覧できます。',
        privateShare: '非公開共有',
        privateTip: 'ヒント：パスワードを入力した後、ファイルを閲覧できます。',
        sourceShare: 'ソース共有',
        sourceTip: 'ヒント：ソースクラウドの共有リンクを作成します。',
        shareSuccess: '共有の作成に成功',
        copySuccess: 'コピーに成功',
        sharedYet: "このファイルはすでに共有されています。",
        domain: 'ドメイン',
        key: 'Key',
        secret: 'Secret',
        progressBox:'進捗状況',
        publicShareEasy: 'すべて',
        privateShareEasy: 'プライベート',
        communityShareEasy: '公開',
        sourceShareEasy: 'ソース',
        reportPopup: {
            title: '共有をレポート',
            beforeMsgOne: 'このリンクは何が起こっているかを理解するために協力してください。',
            beforeMsgTwo: 'どのように説明しますか？',
            typeItems: {
                spam: 'スパム',
                malwareVirus: 'マルウェアまたはウイルス',
                copyrightViolation: '著作権侵害',
                illegal: '違法なコンテンツ',
                notWorking: 'MultCloudは正しく動作しません。',
                other: 'その他の不適切なコンテンツ',
            },
            nextMsgOne: 'このレポートに関する情報を入力してください。',
            description: '説明',
            nextMsgTwo: 'このリンクは何が起こっているか？',
            yourEmail: 'メールアドレス',
            nextMsgThree: 'メールアドレスを提供してください。必要に応じてご連絡いたします。',
            submit: '送信',
            back: '前へ',
            next: '次へ',
            messageNone: 'このレポートについての説明を入力してください。',
            emailNone: '正しいメールアドレスを入力してください。',
            success: 'レポートはMultCloudチームに送信されました。'
        },
        subAccountPopup:{
            title: "サブアカウント管理",
            titleMax: "サブアカウント管理",
            titleDes:"有料ユーザーにアップグレードすると、サブアカウントを作成および管理できるようになります。",
            tabNameUser: "ユーザーモード",
            tabNameItem: "フォルダーモード",
            addItemButton: "フォルダーの割り当て",
            users: "ユーザー",
            folders: "フォルダー",
            read: "読み込み",
            write: "書き込み",
            questionTxtRead: "サブアカウントのユーザーは、このフォルダー内のファイルをダウンロード、プレビュー、およびコピーできます。",
            questionTxtWrite: "サブアカウントのユーザーは、このフォルダー内のファイルを作成、アップロード、削除、名前変更できます。",
            userExist:"ユーザーはすでに存在します。",
            userSelf:"自身のアカウントを追加できません。",
            quickAssign: "クイックアサイン",
            quickAdd: "クイック追加",
            allow: "許可",
            batchAddUserNull: "現在、追加されたユーザーはいません。",
            batchAddItemNull: "現在、追加されたフォルダはありません。",
            noUserFromAddItem: "まず、ユーザを追加してください。",
            noItemFromAddUser: "まず、フォルダを追加してください。",
            addUser: {
                title: "ユーザーを追加",
                radioCreate: "サブアカウントを作成",
                radioAdd: "既存のMultCloudアカウントを追加",
                createNamePlaceholder: "ユーザー名を作成",
                createPasswordPlaceholder: "パスワードを作成",
                addNamePlaceholder: "既存のMultCloudアカウントを入力してください。",
                createNameNone: "ユーザー名を入力してください。",
                createNameMore: "ユーザー名は20文字以内である必要があります。",
                createPasswordNone: "パスワードを入力してください。",
                createPasswordError: "8〜16文字のパスワードを入力してください。",
                addUserNameNone: "既存のMultCloudアカウントを入力してください。",
                addUserNone: "このアカウントは存在しません。",
            },
            addItem: {
                noFolder: "フォルダーを選択してください。",
                exist: "パスが見つかりません。パスが存在するかどうかを確認するか、クラウドを再度追加してください。",
            },
            editUser: {
                title: "サブアカウントを編集",
                namePlaceholder: "ユーザー名を入力",
            },
            cancel: {
                titleUser: "サブアカウントを削除",
                titleItem: "フォルダーを削除",
                msgUser: "このアカウントを削除してもよろしいですか？",
                msgItem: "このフォルダーを削除してもよろしいですか？",
            },
        },
        verifyPopup:{
            verifyTitle:"IDを確認",
            toRecoveryText:"どれも持っていません",
            verifyEmailTitle:"メールアドレスを確認",
            verifyEmailTips:"確認コードを{email}に送信します。お使いのメールアドレスであることを確認するため、確認コードを下に入力してください。",
            verifyPhoneTitle:"電話番号を確認",
            verifyPhoneTips:"確認コードを{phone}に送信します。お使いの電話番号であることを確認するため、{last}を含む最後の4桁を入力してください。",
            verifyPhoneText: "電話番号最後の4桁",
            sendCodeBtn:"コードを送信",
            enterCode:"コードを入力",
            checkEmailTips:"{email}がお使いのアカウントの代替メールアドレスと一致する場合は、コードを送りします。",
            checkPhoneTips:"{phone}がお使いのアカウントの電話番後の最後の4桁と一致する場合は、コードを送りします。",
            askDevice: "このデバイスで再度確認しないでください。",
            verify: "確認",
            recoveryTitile:"アカウント回復用コードをお持ちですか？",
            recoveryTipsOne:"回復用コードをお持ちの場合は、ここで入力してください。回復用コードをお持ちでない場合は、連絡してください",
            recoveryTipsTwo:"回復用コードは25文字、次のような形式です：XXXXX-XXXXX-XXXXX-XXXXX-XXXXX。",
            recoveryCode:"回復用コード",
            recoveryCodeBtn:"回復用コードを使う",
            recoveryChangeTitile: "本人であることを確認できる他の方法はありますか？",
            recoveryEmailChange:"代替メールアドレスを追加",
            recoveryPhoneChange:"電話番号を追加",
            enterEmail:"メールアドレスを入力",
            recoveryNextTitle:"{checkCode}に送信したコードを入力してください",
            recoveryTipsTitle:"個人情報を保護するために、セキュリティ情報の交換には30日かかります！",
            recoveryTips1: "2段階認証を有効にするため、アカウントにサインインするためには最新のセキュリティ情報が必要です。",
            recoveryTips2:"待機期間中は、アカウントでサイトやサービスにサインインすることはできませんが、デバイスにサインインすることはできます。",
            recoveryTips3: "次の方法で待機を回避できる：",
            recoveryTips4:"信頼できるデバイスを使用します。",
            recoveryTips5:"コードを必要としないデバイスをお持ちの場合、今すぐこれを使ってセキュリティ情報を更新してください。",
            recoveryTips6:"セキュリティ情報を見つけます。",
            recoveryTips7:"まだ完全に失われていない可能性はありますか？もし見つけられたら、今すぐ使用してアカウントを再度有効にしてください。",
            recoveryTips8:"待機すると、盗まれたパスワードで他の誰かがあなたのアカウントを乗っ取るのが難しくなります。",
            recoveryPendTitle:"セキュリティ情報の変更はまだ保留中",
            recoveryPendTips1:"{data}でセキュリティ情報の置き換えを要求した",
            recoveryPendTips2:"現在のセキュリティ情報",
            recoveryPendTips3:"代替メールアドレス：",
            recoveryPendTips4:"電話番号：",
            recoveryPendTips5:"新しいセキュリティ情報",
            recoveryPendTips6:"既存のセキュリティ情報を保持したい場合は、",
            recoveryPendTips7: "このリクエストをキャンセルします。",
            recoveryCancelTitle:"新しい回復用コードはこちら",
            recoveryCancelTips1:"アカウントを保護するには、新しい回復用コードが必要です。",
            recoveryCancelTips2:"アカウントへのアクセスを回復する時にこのコードが役立ちます。それを書き留めて安全な場所に保存した方がいいです。回復用コードをデバイスに保存することをお勧めしません。",
            recoveryCancelTips3:"以前に回復用コードをお持ちだった方は、そのコードは無効になっています。代わりにこの新しいコードを使用してください。",
            recoveryCancelTips4:"新しいコードは：",
            recoveryCancelSucTitle:"アカウントに戻りましょう！",
            recoveryCancelSucTips1:"{old}セキュリティ情報の更新がキャンセルされ、現在はアカウントに完全にアクセスできるようになります。",
            recoveryCancelSucTips2:"プロセス({new})を開始する際に使用された連絡先情報は削除されており、アカウントのセキュリティ情報として使用されなくなります。",
            recoveryCancelSucTips3:"\"次へ\"をクリックして、元の操作に戻ります。",
            recoveryCancelErrorTitle:"リクエストを提出",
            recoveryCancelErrorTips: "アカウントはまだ待機期間中です。",
            codeText: "電話番号を入力",
            exception: {
                emailTwoStringError:"正しいメールは\"{errorCode}\"から始まります。",
                validEmail:"正しいメールアドレスを入力してください。",
                phoneLastTwoStringError:"正しい番号は{errorCode}で終わります。",
                validPhone: "電話番後の最後の4桁を入力しなければなりません。",
                verificationCodeExpired:"確認コードの有効期限が切れています。",
                verificationCodeError:"確認コードが正しくありません。コードを確認して、もう一度お試しください。",
                verificationRecoveryCodeExpired:"コードが機能しませんでした。コードを確認して、もう一度お試しください。",
                verificationCodeNull: "確認コードを入力してください。",
            }
        },
        worldBackupPopup: {
            // title:'世界バックアップデー',
            title:'MultCloud特別企画',
            titleTip:'24時間限定セール',
            timerTitle:'特典が終了するまであと...',
            getOffer:'特典',
            tips100Mo:'100GB/月の通信量',
            ps100Mo:'ヒント：未使用のデータトラフィックが蓄積されます。例えば、最初の月は100GBのうち50GBしか消費しておらず、翌月も50GBの追加データトラフィックがあります。',
            tips1200Yr:'1200GB/年の通信量',
            ps1200Yr:'ヒント：未使用のデータトラフィックが蓄積されます。例えば、初年度は1200GBのうち1000GBしか消費しておらず、翌年も200GBの追加データトラフィックがあります。',
            tips2400Yr:'2400GB/年の通信量',
            ps2400Yr:'ヒント：未使用のデータトラフィックが蓄積されます。例えば、初年度は2400GBのうち2000GBしか消費しておらず、翌年も400GBの追加データトラフィックがあります。',
            tipsUnYr:'無制限/年の通信量',
            psUnYr:'ヒント：1年間無制限のデータ通信量',
            tipsUnLi:'無期間/無制限のデータ通信量',
            psUnLi:'ヒント：生涯無制限のデータ通信量！',
            tips1:'10スレッドでファイル転送',
            tips2:'定期的なクラウド転送',
            tips3:'年中無休の優先サポート',
            ps1:'サブスクライバー用に10スレッド、無料ユーザー用に2スレッドあるため、転送速度が大幅に向上します。',
            ps2:'サブスクライバーは、定期的または特別なタイミングで、クラウドからクラウドへの自動転送/同期をスケジュールできます。',
            moPrice:'{price}/月',
        },
        iosPayTipPopup: {
            title: 'Appleサブスクリプションを解約',
            tip: '現在ご利用中の{name}が自動更新の状態（AppleトランザクションID：{id}）になっています。一度解約して再度お試しください。',
            btnTxt: '解約方法',
        },
        appRecommendPopup: {
            title: 'MultCloudモバイルアプリが利用可能になりました！',
            tip: 'すぐにダウンロードして、モバイルデバイスでクラウド<br>間のデータを管理・転送できます。',
            modileTitle: '今すぐMultCloudモバイルアプリを入手！',
            iosBtnTitle: 'からダウンロード',
            iosBtnTip: 'App Store',
            androidBtnTitle: 'で手に入れよう',
            androidBtnTip: 'Google Play',
            apkBtnTitle: 'をダウンロード',
            apkBtnTip: 'MultCloud',
        },
        note: '注意',
        editCloudNoticPopup: {
            tips: '認証の有効期限が切れているため、クラウドをMultCloudに再追加してください。',
            btnTxt: '再追加',
        },
        appleTipsPopup: {
        title: 'ヒント',
        tipTitle: 'iCloudフォト2要素認証に関するヒント',
        tip1: 'iCloudフォトをMultCloudに接続するには、Apple IDにMultCloudサーバーへのアクセス権を付与する必要があります。そのため、2要素認証の際に、サーバーの場所が実際の場所と異なる場合があります。',
        tip2: '覚えておいてください：お客様のセキュリティとプライバシーは最優先事項です。MultCloudは、お客様のデータを永久に保存することはありません。お客様の操作により、コンテンツの一部を一時的にキャッシュすることがありますが、操作終了後、すぐにサーバーから削除されます。また、iCloudフォトとMultCloudのサーバー間の接続は常に安全な256ビットSSLチャネルで行われます。',
        checkTip: '今後表示しない',
    },
    iCloudDriveTips: {
        title: 'ヒント',
        tipTitle: 'iCloud Drive 2ファクタ認証のヒント',
        tip1: 'iCloud DriveをMultCloudに接続するには、Apple IDにMultCloudサーバーへのアクセス権を付与する必要があります。そのため、2ファクタ認証の際に、サーバーの所在地が実際の所在地と異なる場合があります。',
        tip2: 'お客様のセキュリティとプライバシーはこちらの最優先事項であることを忘れないでください。MultCloudは、お客様のデータを永久に保存するわけではありません。お客様の操作に基づき、コンテンツの一部を一時的にキャッシュすることがありますが、操作が完了するとすぐにサーバーから削除されます。また、お客様のiCloud DriveとMultCloudのサーバー間の接続は、常に安全な256ビットSSLチャネルで行われます。',
        checkTip: '今後表示しない', 
    },
    checkApplePopup: {
            title: '二要素認証',
            tip1: '二要素認証がオンになっています。続行するには、iPhone/iPad/iPodにある確認コードを入力してください。',
            tip2: '認証コードを取得できなかった場合',
            btn1: 'メッセージ送信中...',
            btn2: 'コードの再送信',
            btn3: 'メッセージを送信',
            btn4: 'サポート情報',
            suc1: '確認コードを含むメッセージが{num}に送信されました。',
            suc2: '確認コードを含むメッセージがデバイスに送信されました。',
            fail1: '確認コードを送信できませんでした。もう一度お試しください。',
            fail2: '続行するには確認コードを入力してください。',
        },
        downloadThreadPopup: {
            title: "ダウンロード設定",
            tips: "ダウンロードしたファイルの名前",
            defaultNameOne: "Emails saved on {date}",
            defaultName: "{num} emails saved on {date}",
            option1: "添付ファイルを保存",
            option2: "会話形式",
            option2Tips: "チェックを入れると、電子メールによる参照は削除されます。",
            option3: "最後のメッセージのみ保存",
        },
        failedFilesPopup: {
            title: '失敗ファイルの確認：{num}件',
            exportExcel: 'Excelにエクスポート',
            retrySucTip: '{num}件をリトライリストに追加しました。',
        },
        viewLogsPopup: {
            title: 'タスク詳細：',
            titleRe: 'タスク詳細：',
            errorNum: '失敗件数',
            addNum: '追加ファイル数',
            updateNum: '更新ファイル数',
            deleteNum: '削除ファイル数',
            syncSize: '同期サイズ',
            syncTime: '同期時間',
            backupNum: 'バックアップ件数',
            backupSize: 'バックアップサイズ',
            backupTime: 'バックアップ時間',
            restoreNum: '復元回数',
            restoreSize: '復元サイズ',
            restoreTime: '復元時間',
            tranNum: '転送件数',
            tranSize: '転送サイズ',
            tranTime: '転送時間',
            tran: '転送',
            sync: '同期',
            backup: 'バックアップ',
            from: '元',
            to: '先',
            executeTime: '実行時間：',
            sourceAccount:'送信元アカウント',
            targetAccounts:'送信先アカウント',
            executeResult: '実行結果',
            add: '追加：',
            update: '更新：',
            delete: '削除：',
        },
        taskProgressPopup: {
            title1: 'プレミアムユーザー様は、最大10スレッドで同時ファイル転送が可能です。',
            title2: 'プレミアムサービスにアップグレードすれば、最大10スレッドまで利用可能！',
            btnTip: '$9.99から',
        },
        subfileSelectPopup: {
            title: 'アップロードする内容を選択',
        },
        deleteBatchPopup: {
            tips1: '<span>{num}</span> 個のタスクを削除してもよろしいですか？',
            tips2: '削除したタスクは復元できません。',
        },
        freeSaledPopup: {
            tips1: '世界バックアップデーの特別ギフト：もっとスマートにバックアップしよう！50GB無料のクラウド転送量を手に入れよう！',
            tips2: 'ちょっと待ってください！',
            tips3: '世界バックアップデーのギフトをスキップしようとしていませんか？注意：一度スキップすると、この機会は二度と戻ってきません！',
            btns1: '50GBを受け取る',
            btns2: 'いいえ、結構です',
            success: 'おめでとうございます！50GBのクラウド間転送量を獲得しました。',
            floatTitle: '50GB無料ゲット',
            popupTitle: '<span>50GB</span>無料ゲット',
        }
    },
    addCloud: {
        connectDesc: 'クラウドドライブをクリックしてMultcloudに追加します。',
        box: 'box',
        boxBusiness:'box for Business',
        dropbox: 'Dropbox',
        google_drive: 'Google Drive',
         google_drive_sharedWithMe: '共有アイテム',
        google_drive_v2: 'Google Drive',
        google_drive_shared_v2: '共有アイテム',
        oneDrive: 'OneDrive',
        oneDriveV2: 'OneDrive',
        sugarSync: 'SugarSync',
        amazonS3: 'Amazon S3',
        iDrivee2: 'IDrive® e2',
        wasabi:'Wasabi',
        webDav: 'WebDAV',
        FTP: 'FTP',
        cloudMe: 'CloudMe',
        cubby: 'Cubby',
        NAS: 'NAS',
        myDrive: 'MyDrive',
        yandex: 'Yandex',
        hiDrive: 'HiDrive',
        WEBDE: 'WEB.DE',
        baiDu: 'BaiDu',
        amazon: 'Amazon',
        alfresco: 'Alfresco',
        aDrive: 'ADrive',
        Icedrive: 'Icedrive',
        oneDrive4Business: 'OneDrive for Business',
        dropbox4Business: 'Dropbox Business',
        pCloud: 'pCloud',
        mega: 'MEGA',
        backblaze: 'Backblaze',
        putio: 'Putio',
        googlePhotos: 'Google Photos',
        googlePhotosV2: 'Google Photos',
        gSuiteSharedDrive: '共有ドライブ',
        evernote: 'Evernote',
        flickr: 'Flickr',
        mediafire: 'MediaFire',
        ownCloud: 'ownCloud',
        mySQL: 'MySQL',
        gSuite: 'Google Workspace',
        hubiC: 'hubiC',
        egnyte: 'Egnyte',
        youtube1: 'youtube1',
        facebook: 'facebook',
        picasa: 'picasa',
        goDaddy: 'goDaddy',
        ubuntu: 'ubuntu',
        welcomeTo: 'MultCloudへようこそ',
        welcomeFont: '1つのアプリで複数のクラウドファイルを簡単に転送および管理できるようになりました。まず、クラウドをMultCloudに追加してください。',
        peCloud:'個人クラウド',
        buCloud:'ビジネスクラウド',
        sharePointOnline:"SharePoint Online",
        iCloudPhotos: 'iCloud 写真',
        gmail: 'Gmail',
        comingSoon: '近日公開...',
        iCloudDrive: 'iCloud Drive',
        signInWith: '次の方法でサインイン',
        outlook: 'Outlook',
        fourShared: '4shared',
    },
    addEmail: {
    connectDesc: 'メールをクリックしてMultCloudに接続',
    peEmail: '電子メールを選択してサインイン',
    iCloudNotice: 'iCloud Driveは一時的に接続できません。開発チームは現在、問題の解決に取り組んでいます。',
    iCloudPhotosNotice: 'iCloud 写真は一時的に接続できません。開発チームは現在、問題の解決に取り組んでいます。',
},
cloudExploer: {
        uploadFile: 'ファイルをアップロード',
        newFolder: '新しいフォルダ',
        newAlbum: '新規アルバム',
    search: '検索',
        grid: 'グリッド',
        pageList: 'リスト',
        reFresh: '再読み込み',
        modified: '変更時間',
        openWith: '実行ツール',
        officeOnline: 'Microsoft Office オンライン',
        loading: 'ロード中ですので、少々お待ちください！',
        uploadFolder: 'フォルダをアップロード',
        trash: 'ごみ箱',
        recentlyDeleted: '最近削除した項目',
        jumpTo: 'ジャンプ先',
        deleteForever: '永久削除',
        restore: '復元',
        back: '戻る',
        searchResult: '検索結果',
        emptyTrash: '空のごみ箱',
        recoverAll: 'すべて復元',
        deleteAll: 'すべて削除',
        fileExists: 'ファイルが存在しています。',
        chooseOption: 'ファイルが存在します。オプションを選択してください！',
        needRestore: 'このフォルダを表示するには、ゴミ箱から復元する必要があります。',
        limitBoxTip: '1.一部のクラウドドライブにはいくつかの制限がある場合があります。たとえば、Boxは2GBより大きい単一ファイルの送信をサポートしていません。このような制限はクラウドプロバイダーによって設定されており、MultCloudで回避することはできません。詳細については、<a href="https://www.multcloud.com/jp/help/limitations.html" target="_blank" class="add-cloud-link">ここをクリック</a>します。<br>2. プレミアムにアップグレードした後もタスクが10スレッドを取得しない場合は、タスクをキャンセルして再転送してください。vip専用サーバーは転送タスクに10スレッドを取得できます。',
        fileNameNotEmpty: '入力したファイル名は空にできません。',
        notContainSpecialChar: 'ファイル名に特殊文字を含めることはできません`/ \ | : * ? " < >`。',
        CharacterLimit:'ファイル名に特殊文字を含めることはできません`~"# %& *: < >？ / \ { | }.`',
        pathNotExist: 'パスは存在しません。',
        emptyNotice: 'このフォルダは空だ',
        trashEmpty: 'ごみ箱が空です',
        searchEmpty: '検索結果が空です',
        uploadSize: 'アップロードタスクの合計サイズは1GB以下にする必要があります。',
        simultaneous: '最大200のタスクを同時に追加できます。',
        cancelFailed: 'キャンセルできませんでした、タスクを作成しています、しばらくしてからもう一度お試しください。',
        notWith: 'ファイル名とフォルダ名の先頭または末尾を「.」にすることはできません。',
        notUpload: 'アップロードに失敗しました。',
        duplicatePhoto: '重複した写真。アップロードしようとしている写真は重複しており、ライブラリに読み込まれませんでした。',
        dataLoaded: 'ロードされたデータ',
        sharedDate:'共有日',
        failedRestore: 'ターゲットディレクトリに同じファイル名のファイルが含まれているため、ファイルの復元に失敗しました。',
        //2020-12-11 lijimin
        uploadError:'このファイルのダウンロードは許可されていません （公式クラウドサービスにより）。',
        downloadLimit: '本日のダウンロード制限に達しました。明日もう一度お試しください。',
        //2022-4-26 wt
        newBucket:'新しいバケット',
        createBucket:'バケツ名は、小文字のアルファベットと数字のみです。注意：バケット名はすべて数字であってはいけません（例：「12345678」）。',
        deleteBucket:'バケット名がすべて数字（例：「12345678」）である場合、MultCloud はバケットを削除することができません。',
        getBucketObjectListFail :'バケット名がすべて数字（例：「12345678」）である場合、MultCloud でリストアップすることができません。',
        newAlubm: '',
        specialCharError: 'ファイル名に特殊文字を含めることはできません`/ | : * ? " < >`。',
},
emailExploer: {
    from: '送信者',
    to: '受取人',
    cc: 'Cc',
    email: 'メール',
    subject: '主題',
    received: '受信時間',
    sentTime: '送信時間',
    downloadMax200: '一度に最大 200 件のメールをダウンロードできます。',
    noSubject: '（件名なし）',
    folderName: {
        Inbox: '受信トレイ',
        Starred: 'スター付き',
        Snoozed: 'スヌーズ中',
        Sent: '送信済み',
        Drafts: '下書き',
        Important: '重要',
        Chats: 'チャット',
        Scheduled: '予定',
        AllMail: 'すべてのメール',
        Spam: '迷惑メール',
        Trash: 'ゴミ箱',
        Unread: '未読',
        Categories_Social: 'カテゴリ_ソーシャル',
        Categories_Updates: 'カテゴリ_新着',
        Categories_Forums: 'カテゴリ_フォーラム',
        Categories_Promotions: 'カテゴリ_プロモーション',
        Categories_Personal: 'カテゴリ_個人',
    }
},
imageSaver: {
    analyzing: '分析中',
    failedToParse: '解析に失敗しました',
    noviceGuidance: 'ここで、クラウドに最近アップロードされた画像/動画や、Instagram用にパッケージ化された画像/動画を確認できます。',
    insDownloadExist: 'このプロファイルはすでにダウンロードされています。「タスクリスト」セクションにあります。',
    taskExpiredOn: '有効期限 {time}',
    taskStoringTill: '保管期間 {time}',
    taskPart: 'パート',
    taskUnitFile: 'ファイル',
    taskUnitFiles: '個ファイル',
    taskQueue: '待ち中',
    taskTabUpload: 'アップロード',
    taskTabSaveAll: 'すべてをクラウドに保存',
    taskTabDownload: 'すべてのIGをダウンロード',
    downloadInsVideo: 'ビデオをダウンロード',
    downloadSinglePost: '投稿全体をダウンロード',
    downloadAllPosts: 'すべての投稿をダウンロード',
    downloadAllReels: 'すべてのリールをダウンロード',
    downloadAllStories: 'すべてのストーリーをダウンロード',
    downloadAllHighlights: 'すべてのハイライトをダウンロード',
    saveInsVideo: 'ビデオをクラウドに保存',
    saveSinglePost: '投稿全体をクラウドに保存',
    saveAllPosts: 'すべての投稿をクラウドに保存',
    saveAllReels: 'すべてのリールをクラウドに保存',
    saveAllStories: 'すべてのストーリーをクラウドに保存',
    saveAllHighlights: 'すべてのハイライトをクラウドに保存',
    insCardPosts: '投稿',
    insCardFollowers: 'フォロワー',
    insCardFollowing: 'フォロー中',
    insTabPosts: '写真とビデオ',
    insTabReels: 'リール',
    insTabStories: 'ストーリー',
    insTabHighlights: 'ハイライト',
    insBlankText: 'MultCloudのInstagramダウンローダーを使えば、Instagramの投稿、リール、ストーリー、ハイライトを簡単にダウンロードして保存でき、いつでもお気に入りのコンテンツを管理できます。',
    webGoogleBlankText: 'あらゆるウェブサイトやGoogle検索から画像を簡単に収集し、クラウドやローカルストレージに直接保存できます。',
    noTask: 'タスクなし',
    inputTipHttp: 'ウェブサイトのURLまたはGoogle検索キーワードを入力',
    fetchBtn: '今すぐ取得',
    fetchingBtn: '取得中...',
    loadMore: 'もっと読み込む',
    downloadAll: 'すべてダウンロード',
    saveAll: 'すべてをクラウドに保存',
    saveToCloud: 'クラウドに保存',
    clearHistory: '履歴を消去',
    cancel: 'キャンセル',
    retry: '再試行',
    view: '表示',
    noImage: 'コンテンツが見つかりません',
    notSupport: 'このURLはサポートされていません。URLを再度ご確認ください。',
    inputTipIns: 'InstagramのURLを入力',
    post: '投稿数',
    posts: '投稿数',
    uploadTo: 'アップロード先：',
    download: 'ダウンロード',
    uploading: 'アップロード中',
    finished: '終了',
    all: 'すべて',
    videoInputTip: 'ここに動画のリンクを貼り付ける',
    videoTip: `MultCloudの広告なし、クロスプラットフォームのオンラインビデオダウンローダーを使って、YouTube、Facebook、X、その他<a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1000以上のサイトから</a>
    高品質のビデオをダウンロードしましょう。インストールは不要です。`,
    process: '処理中...',
    thumbnail: 'サムネイル',
    abrTypeVeryHigh: '非常に高い',
    abrTypeHigh: '高い',
    abrTypeNormal: '普通',
    abrTypeLow: '低い',
    default: 'デフォルト',
    generat: 'ファイルを生成中',
    retryTip: 'タスクが再起動されました。「すべて」タブで最新の進行状況を確認できます。',
},
taskList: {
        taskListDes: 'ここでクラウド転送、クラウド同期、共有ファイル保存タスクを管理できます。',
        multiCloudSync: 'マルチクラウド同期',
        MultiCloudTransfer: 'マルチクラウド転送',
        nextTransfer: '次の転送',
        scheduled: 'スケジュール',
        nextSync: '次の同期',
        reTransfer: '再転送',
        saveNow: '今すぐ保存',
        transferTasks: '転送タスク',
        syncTasks: '同期タスク',
        shareTasks: '共有タスク',
        backupTasks: 'メール移行タスク',
        emailTransferTasks: 'バックアップタスク',
        allTime: 'いつも',
        today: '今日',
        latestWeek: '先週',
        latestMonth: '先月',
        customDate: 'カスタム日付',
        allStatus: 'すべてのステータス',
        preset: 'プリセット',
        noTaskCreated: 'タスクは作成されていません。',
        createTransferTask: '転送タスクを作成',
        createSyncTask: '同期タスクを作成',
        createRemoteTask: 'リモートタスクを作成',
        timeMustLess: '開始時間は終了時間以下にする必要があります。',
        taskNameRule: 'タスク名は255文字を超えることはできません。',
        backupTaskNameRule: 'タスク名は255文字を超えることはできません。',
        detailNote: 'このタスクはまだ準備中なので、詳細は表示されません。',
        notTraffic: 'クラウドからクラウドへの送信に十分なデータトラフィックがありません',
        reSync:'再同期',
        rebackup:'再バックアップ',
        rerestore:'再復元',
        notFoundAim:'ターゲットディレクトリが見つかりません。',
        //2021-10-11
        createBackupTask:'バックアップタスクを作成する',
        createTeamTransferTask:'チーム転送タスクを作成する',
        multiClouds: 'マルチクラウド',
        speedUP: 'スピードアップ',
        noTasks: 'タスクがありません',
        noTasksTip: '最初のタスクを開始して、シームレスなクラウド間での転送・同期を利用しましょう。',
        loadingTip: '少々お待ちください。',
        allTasks: 'すべてのタスク({num})',
    },
    cloudTransfer: {
        transferDescription: 'クラウド間でファイルを転送するタスクを設定します。',
        transferOperateFrom: 'ここをクリックして、転送元のクラウドドライブまたはフォルダを選択します。',
        from: '転送元',
        to: '転送先',
        transferOperateTo: 'ここをクリックして、転送先のクラウドドライブまたはフォルダを選択します。',
        transferNow: '今すぐ転送',
        transfer: '転送',
        addTaskOnly: 'タスクを追加',
        addTaskNow: 'タスクを追加して今すぐ転送',
        addSyncTaskNow: 'タスクを追加して今すぐ同期',
        addBackupTaskNow:'タスクを追加して今すぐバックアップ',
        transferSucces: '正常に転送しました！',
        sureContinue: '10以上のソースアイテムが選択されました。各ソースアイテムは1つの通知メールに対応します。つまり、10以上の通知メールを受信する可能性があります。続行しますか？',
        sure: 'はい、確認します。',
         //2020-10-29ljm新增
         sourceRemind:' ソースアイテムの最大数は200個です。より少ないアイテムか、フォルダ全体を選択してください。注：フォルダ全体は1つのアイテムと見なされます。',
         backupSourceRemind:'ソースアイテムの最大数は1000個です。より少ないアイテムか、フォルダ全体を選択してください。注：フォルダ全体は1つのアイテムと見なされます。',
         cloudBackupFrom:'バックアップ元',
         cloudBackupto:'バックアップ先',
    },
    cloudSync: {
        syncDescription: 'クラウド間でファイルを同期するタスクを設定します。',
        syncOperateTo: 'ここをクリックして、同期先のクラウドドライブまたはフォルダを選択します。',
        syncOperateFrom: 'ここをクリックして、同期元のクラウドドライブまたはフォルダを選択します。',
        syncNow: '今すぐ同期',
        taskEmpty: 'タスク名を入力してください！',
         //2020-10-29ljm新增
         aimRemind:'ターゲットディレクトリの最大数は200個です。',
         from: '同期元',
         to: '同期先',
         realTimeSync:'リアルタイム同期',
         normalSync:'ベーシック同期',
         pause:'中断',
         paused:'一時停止',
        swicthTwoWay:'双方向同期に切り替る',
        switchOneWay:'一方向同期に切り替る',
        fristSync:'最初の同期',
        lastSync:'最終同期',
        initSync:'データの初期同期はまだ進行中です。しばらくお待ちください。',
        realSyncing:'リアルタイム同期が実行されています...',
        servicesSu:'リアルタイム同期をサポートするクラウドサービス',
        addRealDrives:'リアルタイム同期をサポートするクラウドドライブを追加する必要があります。',
        egDrives:'現時点では、Google Drive、Dropbox、Dropbox Business、OneDrive、OneDrive for Business、G Suite、boxのみがリアルタイム同期をサポートしています。',
        initTial:'初期化中',
        createdAt:'で作成',
        realSync:'リアルタイム同期',
        oneWaySimple:'一方向（シンプル同期）',
        twoWay:'双方向（近日公開...）',
        gooleFolder:'Googleドライブフォルダのサブディレクトリにだけ変更がある場合は同期されません。',
        realTimeNotice:'最大2つのリアルタイム同期タスクを同時に実行できるため、一部のサブタスクは一時停止されます。続行してもよろしいですか？',
        reachMax:'ログ数が上限に達しており、最新のログのみが表示されています。',
        notRun:'タスクが実行されていません。',
        bePaused:'リアルタイム同期タスクが7日以上非稼働状態のままである場合、自動的に一時停止されます。',
        dontShow:'二度と表示しない',
        timeOut:'トラバーサルタイムアウト',
        outMostly:'トラバーサルタイムアウトの主な原因は、リアルタイム同期に必要なファイル数やサブディレクトリ数が多すぎます。代わりに、通常の同期タスクを作成することをお勧めします。'
    },
    emailTransfer: {
        cloudEmail: 'メール移行',
        description: 'メールをPDFとしてクラウドに移行します。',
        migrationSetting: '移行設定',
        cutSetting: 'カット設定',
        copySetting: 'コピー設定',
        settingTips: '',
        notification: '通知',
        watermark: '透かし',
        delWatermark: 'PDFとしてダウンロードしたメールから透かしを削除',
        saveAtt: '添付ファイルを保存',
        converFormat: '会話形式',
        converFormatTip: 'チェックを入れると、電子メールによる参照は削除されます。',
        saveOnly: '最後のメッセージのみ保存',
        optionTitle: '一部のメールは既に存在します。どうしますか？',
        filterTitle: 'ソースボックスに追加のフィルタ条件を指定できます。',
        filterMessage: 'メールアドレスをカンマで区切って入力してください。',
        filterOption1: '会話が更新された場合は上書きされる',
        filterOption2: '常にスキップ',
        filterOption3: '名前を変更',
        filterOption4: '添付ファイルあり',
        filterOption5: '未読',
        transferNow: '今すぐ移行',
        filterDateOptions1: '全期間',
        filterDateOptions2: '1 週間以上前',
        filterDateOptions3: '1 か月以上前',
        filterDateOptions4: '6 か月以上前',
        filterDateOptions5: '1年以上前',
        filterDateOptions6: '期間を指定',
        showMore: 'もっと見る',
        startDate: '開始日',
        endDate: '終了日',
    },
    exception: {
        exceedMaxLimit: 'リクエスト数が上限を超えました。',
        addCloudFailed: '一部のパラメーターが正しく入力されていません。',
        cloudNameExist: 'この表示名は既に存在しています。別の名前を入力してください。',
        pathNotFound: '指定されたパスのファイルまたはフォルダーが存在するかどうかを確認してください。',
        notBeTheSame: '同じなソースフォルダーとターゲットフォルダーを同時に選択することはできません。',
        notTransferring: 'ファイルを転送するためにこのディレクトリを選択することはできません。そのサブディレクトリまたは他のディレクトリを選択してください。',
        verifyCodeInvalid: '確認コードが正しくありません。',
        nameEmpty: '表示名は空にできません',
        emailEmpty: 'メールは空にできません',
        serverEmpty: 'サーバーを空にすることはできません',
        usernameEmpty: 'ユーザー名は空にできません',
        passwordEmpty: 'パスワードは空にできません',
        domainEmpty: 'ドメインは空にできません',
        bucketNameEmpty: 'バケット名は空にできません',
        accessKeyEmpty: 'Access Key IDは空にできません',
        secretAccessKeyEmpty: 'Secret Access Keyは空にできません',
        keyIdEmpty: 'keyIDは空にできません',
        applicationKeyEmpty: 'applicationKeyは空にできません',
        notMediaFiles: '注：アルバムフォルダには写真ファイルのみ保存できます。メディアファイルは保存できません。',
        notStoreDirectories: '写真フォルダにはディレクトリを保存できません。',
        onlyStoreImages: '注：写真フォルダには画像、動画、その他のメディアファイルのみ保存できます。ディレクトリは保存できません。',
        unknownError: 'このサービスへの接続に失敗しました。MultCloudのアクセス権限を再承認してください。',
        renameCloudFailed: 'クラウド名の変更に失敗しました。後で再試行してください。',
        deleteCloudFailed: 'クラウドの削除に失敗しました。後で再試行してください。',
        invalidCloudAccount: 'このクラウドアカウントは存在しません。',
        bindEmailFail: 'メールのバインドに失敗しました。',
        linkHasExpired: 'リンクは有効期限が切れています。',
        listItemsFailed: 'ファイル一覧の取得に失敗しました。MultCloudにクラウドを再度追加してください。',
        deleteItemFailed: '項目の削除に失敗しました。',
        renameItemFailed: '項目名の変更に失敗しました。',
        createFolderFailed: 'フォルダの削除に失敗しました。',
        moveItemFailed: '項目の移動に失敗しました。',
        shareItemFailed: '項目の共有に失敗しました。',
        uploadFailed: 'ファイルデータが見つかりません。',
        toFolderIdBlanked: '「tid」が空白です。',
        downloadFileFailed: 'ファイルのダウンロードに失敗しました。ページを再読み込みするかMultCloudにクラウドを再度追加してください。',
        addTaskFail: 'タスクの追加に失敗しました。',
        taskQuotaLimit: 'クラウド間の転送タスクの最大数1000を超えました。不必要なタスクをいくつか削除してください。',
        deleteTaskFail: 'タスクの削除に失敗しました。',
        maxRunningLimit: '実行中のタスク数が上限に達したため、このタスクを後で追加できます。',
        userCreateFail: 'ユーザーの作成に失敗しました。後で再試行してください。',
        userUpdateFail: 'アカウント情報の変更に失敗しました。ページを再読み込みして再試行してください。',
        createSaltFail: 'ソルトの作成に失敗しました。再試行してください。',
        listFolderFailed: 'フォルダ一覧の取得に失敗しました。クラウドを再度追加してみてください。',
        cloudCategoryInvalid: 'クラウドサービスはサポートされなくなりました。',
        executeTaskFail: 'タスクの実行に失敗しました。インターネット接続を確認してください。',
        parameterInvalid: 'パラメータが無効です。',
        saltInvalid: 'セッションの有効期限が切れています。もう一度ログインしてください。',
        emailInvalid: '有効なメールアドレスではありません。',
        notAuthorized: 'ユーザー名またはパスワードが正しくありません。',
        cloudNameEmpty: '表示名を空にすることはできません。',
        addCloudExpired: 'クラウドの追加に失敗しました。クラウドサービスを再度追加してください。',
        verifyCodeInvalid: '認証コードが無効です。',
        emailExist: 'メールアドレスは既に存在します。',
        exceedMaxLimit: 'リクエストできる最大数を超えています。',
        userIdNotNull: 'ユーザーIDは空です。',
        notFoundTask: 'タスクが見つかりません。',
        noTaskRunning: '実行中のタスクはありません。',
        userNotFound: 'ユーザーが見つかりません。',
        loginerNotFound: 'ログイン者はサポートされていません。',
        deletePermissionLimited:'「削除権限」がないため、この操作を続行できません。',
        notHaveDeletePermission: 'ファイル/フォルダを削除する権限がありません。',
        uploadPermissionLimited:'「アップロード権限」がないため、この操作を続行できません。',
        movePermissionLimited:'「移動権限」がないため、この操作を続行できません。',
        copyPermissionLimited:'「コピー権限」がないため、この操作を続行できません。',
        notHavePermission: '書き込み権限がないため、このファイル/フォルダを貼り付けることはできません。',
        notCreatPermission: '書き込み権限がないか、スペースが不足しているため、バケットまたはフォルダを作成できません。',
        mkdirPermissionLimited:'「フォルダの作成権限」がないため、この操作を続行できません。',
        renamePermissionLimited:'「名前の変更権限」がないため、この操作を続行できません。',
        creatIDriveFolderError: 'オブジェクト名にサポートされていない文字が含まれています。',
        creatIDriveFolderToLong: 'オブジェクト名にサポートされていない文字が含まれています。',
        noUploadPermission: 'アップロード権限がないか、クラウド ストレージの空き容量が不足しているため、このファイルをアップロードできません。',
        bucketNameLongError: 'バケット名の長さは3～63文字にする必要があり、小文字、数字、ドット(.)、ハイフン(-)のみを使用し、文字または数字で始まり、文字または数字で終わり、連続したピリオドは避けてください。',
        bucketNameIsNotIp: 'バケット名をIPアドレスにすることはできません。',
        downloadPermissionLimited:'「ダウンロード権限」がないため、この操作を続行できません。',
        ipNotFound: 'IPが見つかりません。',
        sugarSyncWarn: '選択されたディレクトリにコピーできません。「Web Archive」、「Magic Briefcase」、「Mobile Photos」ディレクトリを選択してください。',
        flickWarn: '選択されたディレクトリにコピーできません。「アルバム」ディレクトリを選択してください。',
        baiDuWarn: '選択されたディレクトリにコピーできません。「全部文件/我的应用数据/MultCloud」ディレクトリを選択してください。',
        dropBoxbusinessWarn: 'ルートディレクトリにコピーできません。他のディレクトリを選択してください。',
        onlyAlbum: 'MultCloudによって作成または共有されているアルバムディレクトリのみ、画像、ビデオ、およびその他のメディアファイルを保存するために選択できます。',
        createFolderFail: 'フォルダの作成に失敗しました',
        parametersNotEmpty: 'パラメーターは空にできません',
        //mega报错
        addMegaFailed: '一部のパラメーターが正しく入力されていないか、F2Aをアクティブにしました。',
        //mySql报错
        mySqlWarn:'このクラウドをクラウド間転送の同期先として選択できません。',
         //2020-10-29ljm新增
         maxTaskRemind:'クラウド転送／同期は最大タスク数（5000個）に達しています。不要なタスクを削除して再試行してください。注：転送タスクに3つのソースがあれば、この転送タスクは3つのタスクと見なされます。' ,
		 // 2020-11-25 yjs
         torrentTort:'注：MultCloudを使用してアクセスが許可されていないか、著作権を侵害している資料をダウンロードまたはアップロードしないでください',
         //2020-12-4 xth
        shareNotUpload:'所有者が「アップロードを許可する」権限をキャンセルしました。ページを最新の情報に更新してください。',
        //2020-12-9 xth
        shareItemUpdate:'所有者がこの共有リンクの権限を変更しました。ページを最新の情報に更新してください。',
        nameLong:'ユーザー名は長すぎて20文字を超えることができません。',
        notPermission:'これはチームファイルであり、この操作を実行する権限がありません。',
        notOpened:'このクラウドはリアルタイム同期をサポートしていません。',
        taskNotFound:'タスクが存在しません。',
        subscribeFail:'タスクの作成に失敗しました。',
        driveAccountIdInvalid:'リアルタイム同期タスクを作成できませんでした。選択したクラウドサービスを削除して再度追加してから、再試行してください。',
        unknownState:'この操作を実行できません。しばらくしてからもう一度お試しください。',
        InvalidParameter:'無効なパラメータ',
        InvalidDirectory:'ボックスのルートディレクトリはこの機能をサポートしていません。',
        HasExist:'このフォルダのインスタント同期タスクはすでに存在します。このフォルダのインスタント同期タスクをキャンセルして、フォルダに再作成してください',
        // taskRunningNumberLimited:'5つのクラウド間タスクを並行して実行できます。実行中のタスクをキャンセルして再試行してください。',
        taskRunningNumberLimited:'実行中のリアルタイム同期タスクはすでに2つあります。まず1つのリアルタイム同期タスクを一時停止してください。',
        reachedLimit:'このクラウドのレート制限に達しました。後でもう一度やり直してください。',
        selectAlbumWarn:'注：アルバムディレクトリには、画像、ビデオ、その他のメディアファイルのみを保存でき、ディレクトリは保存できません。',
        notSupported:'今のリアルタイム同期はマルチターゲットタスクをサポートしていません。',
        incorrectFormat:'申し訳ありませんが、電話番号の形式が正しくありません',
        taskMaximumNumberLimited:'リアルタイム同期タスクの最大数200に達しました。 不要なリアルタイム同期タスクをいくつか削除して、再試行してください。',
        autoLoginFail:'2段階認証を有効にしているので、もう一度ログインしてください。',
        unsubscribeFail:'登録解除に失敗する',
        //云盘操作报错
        alreadyAdd:'クラウドストレージはすでに追加されています。',
        toggleWhileEditing:'追加されたアカウントは現在のアカウントと一致しません。',
        //2022-4-25 wt
        emptyBucket:'空でないバケットを削除することはできません。追記：Wasabiのバケットバージョン管理にもオブジェクトがないことを確認してください。',
        cannotCopyFolder:'フォルダを同じバケットにコピーすることはできません。',
        cannotCopyIdrivee2Folder: '同じIdrive e2アカウント内のフォルダーは相互にコピーすることはできません。',
        cannotCutFolder:'同じバケツの下にあるフォルダ同士をカット＆ペーストすることはできません。',
        bucketAlreadyExists:'要求されたバケット名は利用できません。バケット名前空間は、システムのすべてのユーザーによって共有されます。別の名前を選択して、もう一度やり直してください。',
        accessPermissionLimited:'このフォルダーにアクセスする権限がありません。',
        accessDenied:'アクセスが拒否されました。この操作を実行する権限がありません。',
        shareTransferCanotCopy: '複数アイテムで共有されているルートフォルダをコピーすることは、現時点ではサポートされていません。',
        sharePointOnlineNotTrans:'SharePointのルートディレクトリはファイル転送用に選択できません。サイトのサブディレクトリを選択してください。',
        sharePointListFailed: 'エラー500: InternalServerError。ヒント: このアカウントがSharePointサービスにアクセスできるかどうかを確認してください。',
        sameDirError: 'ソースアカウントとターゲットアカウントを同一にすることはできません。',

        accessDenied:'アクセスが拒否されました',
        //iCloudPhotos报错
        onlySaveAlbums: '注意：選択したターゲットディレクトリは、アルバム（フォルダ）のみを保存できます。',
        notSelectICloudPhotosRoot: 'iCloudフォトのルートディレクトリは、アルバム（フォルダ）のみ保存できます。',
        notSelectICloudPhotosForder: '注意：選択したターゲットディレクトリは、アルバム（フォルダ）のみを保存できます。',
        notSelectICloudPhotosAlbum: '注意：選択したターゲットディレクトリは、画像のみ保存できます（フォルダは使用できません）。',
        notSelectICloudPhotosOther: '選択したターゲットディレクトリは、画像を直接保存することはできません。転送されたすべての画像は、「Recents」フォルダに保存されます。',
        notSelectICloudPhotosBackup: 'iCloudフォトは「クラウドバックアップ」の保存先として選択することはできません。iCloudフォトに画像を保存する場合は、「クラウド転送」または「クラウド同期」を選択してください。',
        notSelectICloudPhotosSyncRoot: 'iCloudフォトのルートディレクトリに画像を同期することはできません。',
        notSelectICloudPhotosSync: 'これはiCloudフォト内のフォルダです。iCloudフォト内のアルバムに画像のみ同期することができます。',
        sendTooMany: '認証コードの送信回数が上限に達しました。最後に受信したコードを入力するか、お使いのデバイスのいずれかを使用するか、または後でもう一度試してください。',
        verifySecurityCodeFailed: '確認に失敗しました。確認コードを確認して再入力してください。',
        appleNotEnablePhotos: 'iCloud写真はお客様のApple IDでは利用できません。iCloud写真を利用するには、Appleデバイスで使用しているApple IDでサインインしてください。',
        tooManyRequests429: 'ユーザーレート制限を超えました。{date}以降に再試行してください。',
        tooManyRequests403: 'リクエストが多すぎます。 後でもう一度やり直してください。',
        // iCloudDrive报错
        folderNameIsTooLong: 'フォルダ名は255文字を超えることはできません。',
        fileNameIsTooLong: 'ファイル名は250文字を超えることはできません。',
        iCloudDriveNotEnoughSpace: 'ファイルをアップロードするための十分なスペースがありません。',
        uploadFileIsTooBig: 'サイズが大きすぎるためアップロードできません。MultCloudでは現在、アップロードの最大サイズが100MBに制限されています。',
        uploudFileSizeIsZero: 'iCloud Driveには0バイトのファイルをアップロードすることはできません。',
        notUploudSpecialFile: 'この種類のファイルはこのAppライブラリにアップロードできません。',
        notRenameApp: 'Appleは、Pages、Numbers、KeynoteなどのAppフォルダの名前を変更することを許可していません。',
        ErrorDeleteDistinguishedFolder: '特定のフォルダーは削除できません。',
        moreThan256Characters: 'フォルダー名は 256 文字を超えることはできません。',
        cloudNotFound: 'クラウドは削除されました。',
        fourSharedUnauthorized:'4sharedの認証が期限切れになりました。「再追加」をクリックしてアカウントを再認証してください。',
        fileFolderNameLengthExceed:"ファイル/フォルダー名の長さは255文字を超えることはできません。",
        invalidLink: '無効なリンク',
        requestFailed: 'リクエストに失敗しました。',
        exceeds2GB: 'ファイルサイズが2GBを超えているため、ダウンロードできません。',
        licenseUpgradError: 'お客様は {scheme} の加入者であるため、ライセンスは利用できません',
        noLicenseCode: 'ライセンスコードを入力してください',
        licenseCodeError: '入力されたライセンスコードが正しくありません',
    },
    preview: {
        fileNotReview: 'ファイルを確認できません。',
        goOringinalSite: '元のページに戻リます。'
    },
    remoteTask: {
        remoteTask: 'リモートタスク',
        createTask: 'タスクを作成',
        successsExceed: 'リンクコピーしました！',
        operateSuccess: '操作が成功しました。',
        noRemote: 'リモートタスクは作成されていません',
        unKnownError: '不明なエラー',
		undefinedDisk:"ターゲットディレクトリが見つかりません。このタスクのリンクをコピーして、新しいリモートタスクを作成してください。",
		taskExpired:'タスクの有効期限が切れるので新しいタスクを作成してください',
        createDescribe:'ファイルをリンク、トレント、マグネットからクラウドに直接転送します',
        saveURLDescribe:'URLからクラウドへファイルを直接保存',
		excuteNow:'今すぐ実行',
		noSeeds:'少ないリソース',
		failedToParse:"解析に失敗しました",
		parseMagnetRunning:'シードを解析しています。お待ちください...',
        selectedFileLimit:'選択したファイルの総数が500を超えたり、サイズが50Gを超えたりすることはできません',
        addLink: 'リンクを追加',
        startEmailSend: 'タスク終了時にメール通知を送信',
        nowUpload: '今すぐアップロード',
    },
    shares: {
        myShares: '私からの共有データ',
        savedShares: '保存された共有データ',
        sharedOn: '共有日時',
        allowedTo: 'アッロードを許可',
        location: '場所',
        shareNull: 'まだファイルを共有していません。',
        shareNullTips: 'ヒント：ファイルを共有するには、ファイルを右クリックして「共有」オプションを選択します。',
        savedShareNull: '共有ファイルはまだ保存していません。',
        savedShareNullTips: 'ヒント：誰かが共有リンクを共有している場合は、ここに保存してすばやくアクセスできます。',
    },
    login: {
        experienceSigning: '登録なしで体験',
        forgotPassword: 'パスワードを忘れた？',
        signIn: 'サインイン',
        rememberMe: '覚えておいてください',
        keepLogin: 'ログイン状態を保持',
        loginWith: 'ログイン',
        email: 'メール',
        password: 'パスワード',
        verificationCode: '検証コード',
        firstName: '名',
        lastName: '姓',
        confirmPassword: 'パスワードを確認',
        createAccount: 'アカウントを作成',
        continueWith: '続行',
        resetMessage: 'リセットメッセージを送信',
        enterEmail: 'サインアップしたメールアドレスを以下に入力してください。パスワードリセット用のリンクを記載したメールが送信されます。',
        enterCorrectEmai: 'メールアドレスを正しい形式で入力してください。',
        passwordCharacters: 'パスワードは8-16文字である必要があります',
        passwordDiff: '入力された2つのパスワードが一致しません',
        enterCode: '確認コードを入力してください。',
        sentSuccess: 'メールは正常に送信されました。',
        successfully: '正常にサインアップ',
        pleaseEmail: 'メールアドレスを入力してください',
        pleasePassword: 'パスワードを入力してください',
        accountActivated: 'アカウントはアクティブ化されていません。',
        enterCorrectPass: '正しいメールアドレスまたは仮アカウント名とパスワードを入力してください。',
        resetPasseord: 'アカウントを保護するには、「パスワードを忘れた」をクリックしてパスワードをリセットしてください。',
        validEmail: '有効なメールアドレスを入力してください',
        enterFirstName: '名を入力してください。',
        enterLastName: '姓を入力してください。',
        reEnterPass: 'パスワードを再入力してください。',
        creatingAccount: 'アカウントを作成すると、本規約に同意するものと見なします。',
        termsUse: '利用規約',
        privacyPolicy: 'プライバシーポリシー',
        thankYou: 'ありがとうございます！',
        checkEmail: 'メールを確認してください',
        confirmRegistration: '登録を確認します。アクティベーションプロセスをスキップして、正常に製品を使用できますが、パスワードを忘れた場合、回復することはできません。',
        noteReceiveEmail: 'メールが届きませんでしたか？',
        receiveConfirmationEmail: '確認メールが届かない場合は、メールでお問い合わせください。',
        buttonResend: 'またはボタンをクリックして再送信します。',
        forgetEmail: 'メールアドレスを忘れましたか？',
        sendEmailSupport: ' サポートにメールを送信します',
        trackDown: 'それを追跡します。',
        passwordnotMatch: '入力したパスワードが一致しません',
        enterVaildPassWord: '有効なパスワードを入力してください',
        usernameNotContain: 'ユーザー名に特殊文字を含めることはできません。',
        updatedSuccessfully: 'データは正常に更新されました',
        thankBindEmail: '拘束力のある電子メールアドレスに感謝します。時間内にアクティベーション電子メールを確認してください',
        failExceedOperation: 'この操作を超過できません',
        enterNewPassword: '新しいパスワードを入力してください',
        confirmPassword: '確認パスワードを入力してください',
        userNameNot: 'ユーザー名は空にできません',
        //login popup用
        signUp: '登録',
        logInButton: 'ログイン',
        logInWith: '次のアカウントでログイン',
        logToMultCloud: 'ｈMultCloudにログイン',
        logEmailInput: 'Eメール／ゲストアカウントの名前',
        verificationIncorrect: '入力した認証コードが正しくありません。',
        signUpTitle: 'サインアップして、毎月5GBのデータトラフィックを無料プレゼント',
        title: "MultCloudを使用してクラウドサービスに転送します。",
        tips: "すでにアカウントをお持ちですか？",
        tips2: "アカウントを持っていませんか？",
        btnTxt: "ログイン中...",
        facebook: "Facebook",
        google: "Google",

        exception: {
            strEmpty: "このフィールドを入力してください。",
            nameToLong: "ユーザー名は20文字以内で入力してください。",
            emailError: "有効なメールアドレスを入力してください。",
            pwdError: "パスワードは8～16文字で入力してください。",
            rePsdEmpty: "パスワードを再度入力してください。",
            rePwdError: "パスワードが違います。",
            codeEmpty: "認証コードを入力してください。",
            codeError: "認証コードは4文字以内で入力してください。",
            verifyCodeInvalid: "認証コードが間違っています。",
            emailExist: "このメールアドレスは既に登録されています。",
            emailPsdError: "メールアドレス・アカウントもしくはパスワードが違います。",
        }
    },
    home: {
        driveNameNotContain: 'ドライブ名に特殊文字`/ \ | : * ? " < >  &`を含めることはできません。',
        cloudDiskName: 'クラウドディスク名は200文字を超えることはできません。'

    },
    sharesPage: {
        linkFailure: 'ごめんなさい、このファイルの共有が停止されました。',
        linkMasking: 'ごめんなさい、共有したファイルがブロックされ、ビューできません。',
        saveCloud: 'クラウドに保存',
        directDownload: '直接ダウンロード',
        saveLink: 'リンクを保存',
        cancelShare:'共有をキャンセル',
        uploadFile: 'ファイルをアップロード',
        newFolder: '新規フォルダ',
        saveLinkSuccessBefore: 'リンクの保存に成功しました。',
        saveLinkSuccessAfter: ' 保存されたリンクを表示',
        saveLinkFail: 'リンクの保存に失敗しました。',
        downloadingFolder: '現在フォルダのダウンロードがサポートされません。',
        downloadingMore: '一度に1つだけのファイルをダウンロードできます。',
        downloadingNone: 'ファイルを選択してください。',
        sharecanceledSuccess: '共有がキャンセルされました。',
        sharecanceledFailed: '共有のキャンセルに失敗しました。',
        newFolderInRoot: '新規フォルダの作成にサブディレクトリを入力してください。',
        uploadFileInRoot: 'ファイルのアップロードにサブディレクトリを入力してください。',
        selectFileTransfer: '転送するファイルを選択してください。',
        createTransferFailed: '転送タスクの作成に失敗しました。',
        createTransferSuccessBefore: '転送タスクの作成に成功しました。',
        createTransferSuccessAfter: ' タスクを表示',
        addCloudService: 'クラウドを追加',
        mustAddClouds: '有効なクラウドを追加してください',
        selectSaveCloudTitle: '選択してください',
        moreClouds:'より多くのクラウド',
        saveLinkExists: 'リンクが既に存在しています。',
        errorShare404: 'ソースファイルが見つかりません。',
        passWordError: '間違ったパスワード',
        passWordNone: 'パスワードを入力してください。',
        passWordInputTitle: 'MultCloudプライベート共有リンク',
        passWordInputMsg: 'パスワードを入力してください。',
        passWordInputButton: 'はい',
        loginErrorMax: 'パスワードを長い間更新していないため、今すぐ更新してください。',
        uploadFolder: '現在ファイルだけをアップロードできます。',
        pleaseSignIn: 'MultCloudにサインインしてください。',
    },
    share:{
        noManageMyShare: "ここですべての共有ファイルを管理できます。",
        noManageSavedShare: "ここで保存した共有をすべて管理できます。",
        unknownError: "共有ファイルが失われました。移動または削除されたかもしれません。",
        privateShareText: "（パスワードを取得するために私に連絡ください）",
    },
    inviteFriends:{
        titleBefor: 'できるだけ多くの友達を招待して、成功した招待から ',
        titleAfter: ' のデータ転送量を獲得しましょう！獲得するデータ転送量制限なし！',
        shareEmailTitle: '招待を共有：',
        shareLinkTitle: '招待リンクを共有：',
        emailSend: '送信',
        emailTip: 'ここにEメールアドレスを追加',
        wonMonthFlows: '今月獲得した無期限の追加転送量：',
        wonMonthTitle: '無期限無制限データ転送量を獲得するチャンスを手に入れましょう！',
        lastWinner: '前月の勝者 ',
        winnerInvites: '{num}人招待しました',
        winnerTip: '無期限無制限データ転送量を得た',
        statusTitle: '共有状態',
        successInvites: '今月の成功した招待：',
        chanceWin: '勝つチャンス： ',
        tipsTitle: '規約',
        tipsOne: '招待されたユーザーが電子メールアドレスを確認すると、招待が成功したと見なされます。',
        tipsTwo: '人々を招待することによって獲得するデータ転送量の制限はありません。',
        tipsThird: 'すでに無制限データ転送量のユーザーである場合、成功した招待から2GBを獲得することはできませんが、無期限無制限サービスを獲得するチャンスは2倍になります。',
        shareText: 'MultCloud-1つのアプリで複数のクラウドファイルを転送および管理します。今すぐMultCloudを使用して、2GBのクラウド間データ転送量を獲得しましょう！',
    },
    paySystem:{
        billed:'追加の転送量に12円／GBを支払ってください。',
        subCould:'150GBの転送量が足りない場合、有料会員は追加の転送量に50GB／680円、100GB／1,180円の料金を支払う必要があります。',
        limitedMonth:'150GB/月',
        limitedTrafficMonth:'150GB トラフィック/月',
        unlimitedTraffic:'転送量無期限無制限！',
        foraYear:'年間転送量無制限',
        noNeedPurchase:'追加の転送量を購入する必要はありません。',
        yearlyPayment:'毎年払い（832円/月）',
        validityData:'購入したデータ転送量の有効期限はありません。',
        additionalPackage:'追加の転送量',
        subscriptmc:'MultCloudの購読',
        upgradeMore:'MultCloudプレミアムにアップグレードして、追加の転送量とメリットを獲得しましょう！',
        recommended:'推奨',
        toUnlimited:'無制限にアップグレード',
        otherPlan:'その他のプラン',
        moreTraffic:'追加の転送量を購入',
        monthlySubscriber:'月間ユーザーであり、クラウド間で毎月データを転送または同期するための150GBの転送量があります。',
        moreDetails:`<a class='add-cloud-link sysLink'>特権の詳細</a>`,
        dataTraffic:'今月の転送量の使用量',
        cloudTraffic:'クラウド間の転送量',
        buyNow:'今すぐ購入',
        specialOffer:'特別なオファー',
        lifetimeFree:'生涯無料',
        unsubscribe:'購読を解除',
        includes:'包含',
        reSubscription:'再購読',
        monthTraffic:'月間転送量無制限',
        threeMonth:'30GB/月',
        monthlyPayment:'毎月払い',
        monthlyUnlimited:'月間無制限',
        gb:'GB',
        YearlyUnlimited:'年間無制限',
        YearlyPaymentNine:'毎年払い(1,165円/月)',
        Onetime:'1回払い',
        twoMonthree:'200GB/月 x3',
        QuarterlyPayment:'四半期払い(960円/月)',
        fourMOne:'400GB/月 x12',
        quarterlySubscriber:`シーズン間ユーザーであり、クラウド間で毎月データを転送または同期するための200GBの転送量があります。`,
        yearlySubscriber:`年間ユーザーであり、クラウド間で毎月データを転送または同期するための400GBの転送量があります。`,
        expireIn:'有効期限',
        billYearly:'毎年請求',
        billMonthly:'毎月請求',
        billQuarterly:'四半期ごとに請求',
        twoMonTrafficthree:'200GB トラフィック/月 x3',
        fourMTrafficOne:'400GB トラフィック/月 x12',
        deleteSubAccount:'アカウントを削除するには、登録を解除する必要があります。これを実行してもよろしいですか？',
        payFirst:'購読についての重要なメールを受信できるように、購読の前に',
        paybindEmail:`<a class='add-cloud-link sysLink'>電子メールアドレスをバインドし、認証する必要があります。</a>`,
        payEnd:'サブスクリプションに関する重要な電子メールを正常に受信できるようにする必要があるため、最初にサブスクリプションを行う前に。',
        yearlyPaymentTxt:'毎年払い',
        quarterlyPaymentTxt:'四半期払い',
          //2021-5-20新加
        //1
        upUnlimited:'年間無制限にアップグレード',
        //2
        payDiff:'差額のみお支払いください！',
        //3
        yearlyUnlimit:'MultCloud（<b>年間無制限</b>）',
        //4
        providesUnlimited:'年間無制限プランは、クラウド間でデータを転送または同期するために12か月間無制限のデータ転送量を提供します。',
        //5
        subProduct:'これは、費用がかかるサブスクリプション製品です',
        perYear:'年間',
        cancelSubscription:'サブスクリプションはいつでも解約できます。',
        //6
        defaultPayment:'デフォルトのお支払い方法はXXXです',
        //7
        anotherPayment:'別のお支払い方法をご希望の場合は、',
        clickHere:'こちらをクリックしてください',
        //8
        tryAgain:'現在、お支払いはできません。お支払い方法を確認して、もう一度お試しください',
        //9
        contactPayment:'支払いに問題がありますか？<a href="mailto:support@multcloud.com">support@multcloud.com</a> までお気軽にお問い合わせください。',
        //10
        Notice:'お知らせ',
        beforeBind:'購読する前にメールアドレスをバインドしてください。',
        processorder:'注文処理中',
        eachGbMoney:'13.6円/',
        eachGbMoneyT:'11.8円/',
        payCouponQuartly:'四半期払い(726.67円/月)',
        payCouponlimitedYearly:'毎年払い(640円/月)',
        payCouponunlimitedYearly:'毎年払い(823.33円/月)',
        payCouponunlimitedYearlyLow:'毎年払い(776.67円/月)',
        tips:'何かご質問があればお気軽に <a href="mailto:support@multcloud.com">support@multcloud.com</a>まで連絡してください。',
        monthly:'毎月150GB',
        //新版付费页面
        payTitle: 'あなたに最適なMultCloudをお選びください！',
        limitedData: '制限付きデータ',
        unlimitedData: '無制限のデータ',
        monthly: '月間',
        annually: '年間',
        save58: '最大58％割引',
        payTip: '営業チームにお問い合わせください',
        limitTips: '未使用のデータトラフィックが蓄積されます',
        unlimitTips: 'もうデータ制限の心配はありません',
        tips2: 'オンライン購入時に問題が発生した場合は、お気軽にお問い合わせください：<a href="mailto:support@multcloud.com">support@multcloud.com</a>',
        vipUpgradeTips: 'これは{type}プランのユーザー向けのオファーです。',
    tabPayScheme: {
            perMonth: '月払い',
            perYear: '年払い',
            perNextYear: '1年目（2年目以降{price}）',
            refundDays: '日間返金保証',
            advanced: '高度な機能',
            payPremium: 'プレミアムプランにアップグレードすると、以下のすべての高度な機能をご利用いただけます。',
            payUnlimited: '無制限のプランにアップグレードすると、以下のすべての高度な機能をご利用いただけます。',
            freeTip1: 'より多くのデータトラフィック',
            freeTip2: '無制限のデータトラフィック',
            freeTip3: '自動転送/同期/バックアップ',
            freeTip4: '二重同期',
            freeTip5: '10 転送スレッド',
            freeTip6: '8つの同期モード',
            freeTip7: 'ファイルフィルター',
            freeTip8: 'VIP転送サーバー',
            freeTip9: 'VIPカスタマーサポート',
            freeTip10: '5つのクラウド間タスクを並行して実行',
            freeTip11: '無制限のメール変換数',
            freeTipTitle1: 'サブスクライバーは、2つのリアルタイム同期タスクと2つの通常同期タスク（合計4つ）を作成することができます。',
            freeTipTitle2: 'サブスクライバー用の転送スレッドは10個、無料ユーザー用の転送スレッドは2個あります。',
            freeTipTitle3: '双方向同期と一方向同期の7つのカスタムオプション、ミラー同期がサポートされています。',
            freeTipTitle4: 'フィルタを設定して、ユーザー定義のファイル名または特定の拡張機能を使用してファイルを自動的に転送または同期します。',
            freeTipTitle5: 'サブスクライバーは5つのクラウド間タスクを並行して実行でき、無料ユーザーは一度に1つのタスクを実行できます。',
            freeTipTitle6: '購読者はメールをPDFに無制限に変換できますが、無料ユーザーは月に50通に制限されています。',
        },
        nowPayScheme: {
            clearInsCountText: 'ただし、未使用のInstagramプロフィールのダウンロード枠はリセットされます。',
            manageYourPlan: 'サブスクリプションを管理する',
            price: '価格',
            paymentMethon: '支払い方法',
            autoRenewal: '自動更新',
            priceVat: '{currency}{vatPrice}の付加価値税（{currency}{netPrice}の{percent}％）が含まれています。',
            defaultPayment: '{method}、xxxxxxxxxxxx{num}です。',
            paypalPayment: 'デフォルトの支払い方法はPayPalです。',
            changePayment: 'お支払い方法を変更',
            activated: '次回請求日 {time}',
            deactivated: '次回請求日 {time}',
            appleTip: '現在ご利用中の{name}はApple Storeで購入されたものです。',
            appleTipId: 'AppleトランザクションID：{id}',
            googleTip: '現在ご利用中の{name}はGoogle Playで購入されたものです。',
            googleTipId: 'Google Play注文ID：{id}',
            appNextTimeTip: '自動更新が有効になっています。次回の請求日は{time}です。',
            appNoSubscribe: '自動更新は無効になっています。',
        },
        // 免费用户弹窗
    freePlanPopup: {
        title_traffic: 'おっと！クラウド間トラフィックが足りない',
        title_ins: 'ダウンロード数が上限に達しました',
        title_pdf: 'メールからPDFへの変換の制限に達しました',
        title_modes: '選択した同期モードはプレミアムプラン限定',
        title_remote: 'リモートアップロードの制限に達しました',
        title_subtasks: 'チーム転送の制限に達しました',
        title_scheduled: '定期実行機能はプレミアムプラン限定です',
        title_speed: '5倍の転送速度はプレミアムプラン限定',
        title_sync: '通常同期の制限に達しました',
        title_real: 'リアルタイム同期の制限に達しました',
        title_filter: 'ファイルフィルターはプレミアムプラン限定',
        desc: 'すべての高度な機能をアンロックするためにアップグレード',
        itemTitle_th: '機能と利点',
        itemTitle_traffic: 'クラウド間トラフィック',
        itemTitle_ins: 'Insプロファイルをダウンロード',
        itemTitle_pdf: '電子メールをPDFに変換',
        itemTitle_modes: '同期モード',
        itemTitle_remote: 'リモートアップロードタスクの同時実行数',
        itemTitle_subtasks: 'チーム間で移行可能なサブアカウント数',
        itemTitle_scheduled: 'スケジュール転送／同期／バックアップ',
        itemTitle_speed: '転送速度',
        itemTitle_sync: '通常同期タスクの同時実行数',
        itemTitle_real: 'リアルタイム同期タスクの同時実行数',
        itemTitle_filter: 'ファイルフィルター',
        itemTitle_tran: 'VIP転送サーバー',
        itemTitle_customer: 'VIPカスタマーサポート',
        itemTitle_watermark: 'PDFメールから透かしを削除',
        itemValue_cur: '現在',
        itemValue_free: '無料',
        itemValue_upgrade: 'XXにアップグレード',
        itemvalue_premium: 'プレミアム',
        itemvalue_5gb: '5 GB / 月',
        itemvalue_1profile: '1プロフィール / 月',
        itemvalue_50emails: '50メール / 月',
        itemvalue_maxUnlimited: '最大無制限',
        itemvalue_unlimited: '無制限',
        button: '1,180円 からアップグレード',
    },
        // 套餐的支持项
        supportItem: {
            yourCurPlan: '現在のプラン',
            // 第1组
            gb5: '月間5GBの無料データトラフィック',
            gb100: '月間100GBの無料データトラフィック',
            gb200: '月間200GBの無料データトラフィック',
            gb1200: '年間1200GBの無料データトラフィック',
            gb2400: '年間2400GBの無料データトラフィック',
            gbUnlimitedYear: 'データ通信量年間無制限',
            gbUnlimitedLifetime: '無期限無制限のデータトラフィック',
            gbPackage50: '',
            gbPackage100: '',
            gbGiveAway500: '',
            gbGiveAway200: '',
            ins1: '月に 1 つの Ins プロフィールをダウンロード',
            ins10: '月に 10 個の Ins プロフィールをダウンロード',
            ins20: '月に 20 個の Ins プロフィールをダウンロード',
            ins120: '年に 120 個の Ins プロフィールをダウンロード',
            ins240: '年に 240 個の Ins プロフィールをダウンロード',
            insPackage50: '',
            insPackage100: '',
            insGiveAway500: '',
            insGiveAway200: '',
            pdf50: '月に50通のメール変換数',
            pdfUnlimited: '無制限のメール変換数',
            threads2: 'データ転送用の2つのスレッド',
            threads10: 'データ転送用の10スレッド',
            scheduled: 'スケジュールされた転送/同期/バックアップ',
            // 第2组
            acrossClouds: 'クラウド間の転送/同期/バックアップ',
            offline: 'オフライン転送/同期/バックアップ',
            subAccounts3: 'チーム間で3つのサブアカウントを移行',
            subAccounts1000: 'チーム間で千個のサブアカウントを移行',
            highSpeed: '高速データ転送',
            // 第3组
            syncMode4: '4つの一方向/双方向同期モード',
            syncMode10: '10の一方向/双方向同期モード',
            realSync: 'リアルタイム同期',
            passwordProtected: 'パスワードで保護された共有機能',
            subAccounts: 'サブアカウントのコラボレーション',
            // 第4组
            cloud30: '30以上 の主流クラウドストレージ',
            unlimitedCloud: 'クラウドアカウントを 無制限 に追加',
            singleLog: '一度にすべてのクラウドにログイン',
            support365: '24時間年中無休の優先サポート',
            // 其他
            unlimitedDataTraffic: '無制限のクラウド間データトラフィック',
            unlimitedInsProfile: 'Insプロファイルの無制限ダウンロード',
            unlimitedAllFeatures: 'すべてのプレミアム機能',
            // VIP弹窗标题
            vipPopupTitleTraffic: 'データトラフィックを使い切りました！',
            vipPopupDescTraffic: 'アップグレードして無制限のデータトラフィックを入手',
            vipPopupTitleIns: 'Instagramプロフィールのダウンロードを使い切りました',
            vipPopupDescIns: '有料プランにアップグレードして、Instagramプロフィールを無制限にダウンロード',
        },
        //套餐arguments参数翻译
        arguments: {
            //参数名
            title: {
                monthly100GB: '100GB/月',
                monthly200GB: '200GB/月',
                monthlyUnlimit: '月間無制限のデータ',
                yearly1200GB: '1200GB/年',
                yearly2400GB: '2400GB/年',
                yearlyUnlimit: '年間無制限',
                lifetimeUnlimit: '無期限無制限',
                package50GB: '50GB',
                package100GB: '100GB',
                giveAway500GB: '500GB',
                giveAway200GB: '200GB',
            },
            tips: {
                monthly100GB: '例：初月は100GBのうち50GBしか消費しておらず、翌月は50GBの追加データトラフィックがあります。',
                monthly200GB: '例：初月は200GBのうち150GBしか消費しておらず、翌月は50GBの追加データトラフィックがあります。',
                monthlyUnlimit: '',
                yearly1200GB: '例：初年度は1200GBのうち1000GBしか消費しておらず、翌年は200GBの追加データトラフィックがあります。',
                yearly2400GB: '例：初年度は2400GBのうち2000GBしか消費しておらず、翌年は400GBの追加データトラフィックがあります。',
                yearlyUnlimit: '',
                lifetimeUnlimit: '',
                package50GB: '例：今月は50GBのうち20GBしか消費していないため、未使用の30GBは翌月に残ります。',
                package100GB: '例：今月は100GBのうち20GBしか消費していないため、未使用の80GBは翌月に残ります。',
            }
        },
    },
    //双重验证功能
    twoStepverification:{
        bind: 'メールを最初にバインド',
        addVerify: '確認する方法を追加する必要があります。',
        phoneNotEmpty:'電話番号を空にすることはできません。',
        addPhone:'電話番号を追加する',
        addAlEmail:'予備のメールアドレスを追加する',
        verifySet: '検証設定',
        addWayVerify:'確認する方法を追加する',
        enterEmail: 'メールを入力する',
        enterPhone: '電話番号を入力する',
        enterCode: '送信したコードを入力してください',
        enterCodeTip:'迷惑メールフォルダをチェックし、迷惑メールでないことを報告するか、「no-reply@multcloud.email 」をホワイトリストに追加してください。',
        codeExpired: '検証コードの有効期限が切れています。',
        codeinCorrect: '検証コードが正しくありません。コードを確認して、もう一度お試しください。',
        verifyTurnOn:'二段階認証がオンになっている',
        recoverAccess:'アカウントへのアクセスを回復する必要がある場合は、このコードが役立ちます。それを書き留めて、安全な場所に保管する必要があります。デバイスに回復コードを保存しないことを強くお勧めします。',
        longValid: '前に回復コードを持っていた場合、それはすでに無効になっています。代わりにこの新しいコードを使用してください。 ',
        removeAll: 'すべてのデバイスを削除します？',
        lostAccess:'信頼できるデバイスにアクセスできなくなった場合は、これを行うことをお勧めします。',
        removeMethod: '検証方法を削除しますか？',
        removeMethodSure: '検証方法を削除してもよろしいですか？削除すると、検証に使用できなくなります。',
        getRecode: '新しいコードを生成する',
        emailCode: 'メールでコードを送信する',
        TextCode: 'テキストメッセージでコードを送信する',
        useAccount: '今、一時的なアカウントを使用しています。メールをバインドして、もう一度お試しください。',
        removeTrusted:'信頼できるデバイスをすべて削除します',
        finish:'仕上げる',
        newCode:'あなたの新しいコードは',
        twoStep:'2段階認証',
        twoStepis:'2段階の検証は',
        on:'オン',
        off:'オフ',
        cancel:'キャンセル',
        toManyCodeSend:'確認コードの送信が一定回数を超えた',
        verifyIdenti:'で本人確認',
        codeCopied:'コピー済み!',
        copyCode:'コードをコピー',
        trustedDevice:'信頼できるデバイスが削除されました！',
        phoneValueTips:'ヒント：先頭のゼロを削除し、スペース、ダッシュ、カッコを全て取り除いてください。',
    },
    cloudBackup:{
        cloudBackup:'クラウドバックアップ',
        setUpCloud:'クラウドバックアップタスクを設定してクラウド間でオンラインファイルをバックアップする',
        filesBckupTarget: 'ターゲットディレクトリ',
    filesBckup:'バックアップ元',
        selectSoure:'ここをクリックして、バックアップしたいソースクラウドファイルを選択する',
        saveBackup:'バックアップ先',
        selectTarget:'ここをクリックして、バックアップを保存するターゲットクラウドを選択する',
        backupNow:'今すぐバックアップ',
        canSelect:'最大10000アイテムを選択できる',
        backupFiles:'ファイルをGoogleフォトにバックアップすることはできません。',
        notSelectEvernoteBackup: 'ファイルをEvernoteにバックアップすることはできません。',
      backFlickr:'ファイルをFlickrにバックアップすることはできません。',
        thankSubscrib:'この度は弊社のサービスをご利用いただきありがとうございます。現在、最大10個のファイルを同時にバックアップできます。',
        maximunBack:'最大2つのファイルを同時にバックアップすることができるようになりました。プレミアムサービスにアップグレードすると、最大10個のファイルをバックアップできます。',
        backSuccess:'バックアップ成功',
        backFailure:'バックアップ失敗',
        successBck:'すべてのファイルが成功にバックアップされた',
        taskCanceled:'タスクが手動でキャンセルされた',
        notRestore:'復元するファイルが見つかりません。すでに削除されている可能性があります。',
        selectVersions:'バージョン選択',
        restoreOptions:'復元オプション',
        selectFiles:'復元したいファイルを選択します。',
        toRestore:'復元するファイルを選択してください。',
        originalLocation:'元の場所',
        thankRestore:'この度は弊社のサービスをご利用いただきありがとうございます。現在、最大10個のファイルを同時に復元できます。',
        restoreSimult:'最大2つのファイルを同時に復元することができるようになりました。プレミアムサービスにアップグレードすると、最大10個のファイルを復元できます。',
        restoreSuccess:'復元成功',
        restorePartial:'復元が部分的に成功',
        restoreFailure:'復元失敗',
        notRestore:'復元するファイルが見つかりません。すでに削除されている可能性があります。',
        backupTime:'バックアップ時間',
        changedFiles:'変更されたファイル',
        deleteVersion:'バックアップバージョンを削除してもよろしいですか？',
        deleteFiles:'このバージョンのファイルを削除する',
        keepLatest:'常に最新のファイルを保持します',
        overWriteFile:'ファイルを上書きする',
        skipFile:'ファイルをスキップする',
        versions:'バージョン',
        backupTask:'バックアップタスク',
        readdCloud:'クラウドを再追加',
        selectedCloud:'選択したクラウドの一部は、クラウドバックアップがリリースされる前にMultCloudに追加されました。クラウドをMultCloudに再度追加して、再試行することをお勧めします。',
        continueAnyway:'続行',
        selectedHasAdded:'選択したクラウドは、クラウドバックアップがリリースされる前にMultCloudに追加されました。クラウドをMultCloudに再度追加して、再試行することをお勧めします。',
        failCreate:'バックアップタスクの作成に失敗しました。',
        failLoad:'読み込みに失敗',
        pleaseReAdd:'クラウドをMultCloudに再度追加してください。',
        alreadyAdd:'クラウドストレージはすでに追加されています。',
        failRename:'該当フォルダが見つからないため、名前の変更に失敗しました。',
        taskRuning:'タスクは実行中です。完了するまで待ってから、再試行してください。',
         //2021-08-07添加
        oneBackup:'同時に実行できるバックアップまたは復元タスクは1つだけです',
        restoreTask:'復元タスク',
        restoreOriginal:'元の場所へ復元する',
        restoreNewLocation:'新しい場所に復元する',
         //2021-08-12添加
         backingUp:'バックアップ',
         restoring:'復元',
         restore:'戻す',
         backup:'バックアップ',
          //2021-08-17添加
        maxNum:'ソース内部の最大数は1000です。より少ない項目を選択してください。注：フォルダ全体で1つのアイテムのみがカウントされます。',
        maxLogs:'ヒント：結果は切り捨てられます。ここでは失敗したファイルが最大1,000個まで表示されます。',
        backupDetails:'バックアップの詳細',
        keepTwoFile:'2つのファイルを保持する',
        restoreDetails:'詳細を復元',
        longerDelete:'削除するファイルが多い場合は、かなり時間がかかります。',
        //2021-10-20
        backupNotWork:'バックアップサービスが機能していません',
         //2021-10-28
         backupPartial:'バックアップの部分的な成功',
         configFile:'(構成ファイルをアップロード中)',
         successRestore:'すべてのファイルの復元に成功しました。',
         notFind:'設定ファイルが見つかりません。設定ファイルが存在するかどうか、クラウドドライブとMultCloudの接続が有効であるかどうかを確認してください。',
        selectRestoreItems:'復元したいファイルを選択してください。',
        selectRestoreTotles:'復元するディレクトリを選択してください。',
        original: 'オリジナル',
        inTotalTip: '{count} つのファイル、合計 {size}',
    },
    affiliateProgram: {
        leftTitle: "アフィリエイトになる",
        title: "MultCloudアフィリエイトプログラム",
        headTips1: "最大<span>50%</span>のコミッション率を獲得できます。",
        headTips2: "数回のクリックだけで、<span>無料</span>でサインアップできます。",
        headTips3: "追加条件なく、<span>誰でも<</span>アフィリエイトになれます！",
        signUpBtn: "アフィリエイトアカウントにサインアップ",
        tips: "ヒント：すでにCleverbridgeのアフィリエイトである場合は、<a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\">サインイン</a>してください。",
        howDoTipsTitle: "どう機能している",
        howDoTipsMsg: "当社のアフィリエイトプログラムにサインアップしてログインすると、\"キャンペーン - キャンペーンに参加\"タブの下にAOMEI International Network Limitedが表示されます。それをクリックして、参加を確認します。キャンペーンに参加すると、すべての利用可能なMultCloud製品が表示されます。誰かが紹介リンクを介してMultCloudをアップグレードした場合、<span>30%-50%</span>のコミッション率で報酬が支払われます。",
        FAQsTitle: "MultCloudアフィリエイトプログラムのFAQ",
        FAQ1: "アフィリエイトプログラムはどのように機能しますか？",
        answer1: "顧客が紹介ページで支払いを済ませると、翌月の初めに報酬を受け取ることができます。",
        FAQ2: "素晴らしい。どうサインアップすればよいですか？",
        answer2: "上記の\"アフィリエイトアカウントにサインアップ\"をクリックしてサインアップできます。わずかのステップで、アフィリエイトアカウントを手に入れます。",
        answerPs2: "ヒント：コンソールにサインインすると、\"キャンペーン\"タブの下にAOMEI International Network Limitedが表示されます。それをクリックして、参加を確認します。",
        FAQ3: "どのくらいのコミッションがもらえますか？",
        answer3: "コミッションは契約プランによって異なります。例えば、月間プランのコミッション率は30％ですが、無期間無制限プランのコミッション率は50％となります。",
        FAQ4: "どう報酬を受け取りますか？",
        answer4: "それは、入力した「お支払い方法」によって異なります。お支払いは毎月初めに行われます。",
        answerPs4: "ヒント：各支払いに最低額の制限はありません。",
        anyQuestionTitle: "何かご質問はありますか？",
        anyQuestionTip: "お気軽に<a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>にお問い合わせください。",
    },
    signUp: {
        pwdTip: "パスワード（8-16文字）",
        signingUp: "サインアップ中…",
        tips2: "アカウントを作成すると、 <a href=\"https://www.multcloud.com/jp/terms\" class=\"alink\">利用規約<a/>と<a href=\"https://www.multcloud.com/jp/policy\" class=\"alink\">プライバシーポリシー<a/>に同意したことになります。",
        emailPushTip: "このチェックボックスをオンにすると、MultCloudからの製品、サービスの更新、特別オファー、イベントに関するメールを受信することに同意したことになります。なお、いつでも購読を中止することができます。",
    },
    forgetPwd: {
        title: "パスワードをお忘れですか？",
        tip: "メールアドレスを入力すると、パスワードをリセットするためのリンクをお送りします。",
        sending: "メッセージの送信中...",
        btnTxt: "リセットメールを送信",
        tips1: "メールアドレスをお忘れですか？",
        tips2: "サポート宛にメールを送信",
        tips3: "そして、こちらは追跡します。",
    },
    balackFriday: {
        lastTip: "まもなく終了！お見逃しなく！！",
        title: "ブラックフライデーとサイバーマンデーに早めにアクセスして、無制限のクラウド間データトラフィックを70%オフで手に入れましょう！",
        titleTip: "在庫限り！お早めにどうぞ",
    },
    christmas: {
        payTxt: "クリスマスセール",
        popupTitle: "マルチクラウドスーパーセール",
        pageTitle: "無制限のクラウド間データトラフィックを{num}%オフで手に入れよう！",
        pageTitle2: "{num}%オフで無期限無制限のデータトラフィックを手に入れましょう！",
        paysysTitle: "無くなる前に急いで！",
        popupTip1: "無制限のクラウド間データトラフィック",
        popupTip2: "10個の高速データ転送スレッド",
        popupTip2Append: "プレミアムユーザーには10個の転送スレッド、無料ユーザーには2個の転送スレッドがあります",
        popupTip3: "スケジュール転送/同期/バックアップ",
        popupTip4: "一方向/双方向リアルタイム同期",
        popupTip4Append: "プレミアムユーザー向けに7つの同期モードが追加されます。ミラー同期がサポートされています",
        saledBtn: "今すぐ購入",
    },
    teamTransfer:{
        teamTransfer:'チーム転送',
        transferMultiple:'複数のクラウドプラットフォームアカウント間の移行 (Google Workspace、OneDrive for Business、Dropbox Business、Box for Business, Shared Drive).',
        businessCloud:'ビジネスクラウドの管理者であれば、この機能を使用して、すべてのアカウントをあるビジネスクラウドから別のビジネスクラウドに簡単に移行することができます。例えば、各ユーザーはクラウドプラットフォームに独自のフォルダーを持ち、MultCloudは2つの異なるビジネスクラウドからフォルダを自動的にペアリングし、ファイルを1つのクラウドから別のクラウドに移行できます。',
        clickSelect:'ここをクリックして、転送元のソースビジネスクラウドサービスを選択します。',
        sourceAccount:'転送元アカウント',
        targetAccounts:'ターゲットアカウント',
        autoMatch:'オートマッチ',
        likeTransfer:'ここをクリックして、転送先のターゲットビジネスクラウドサービスを選択します。',
        youMust:'最初に管理者',
        cloudService:'としてビジネスクラウドサービスを',
        asAdmin:'追加する必要があります。',
        combinations:'オートマッチは現在の組み合わせをクリーンアップしますが、続行してもよろしいですか？',
        nosourceAccount:'転送元アカウントまたは転送先アカウントがありません。',
        noAccount:'オートマッチ用のアカウントはありません。',
        uploadCSV:'CSVをアップロードする',
        cleanCurrent :'CSVをアップロードすると、現在の組み合わせがクリーンアップされます。続行してもよろしいですか？',
        csvFile:'アップロードするCSVファイルは、',
        csvFormat:'.CSV形式である必要があります。',
        matchCsv:'組織はCSVファイルのどの組み合わせとも一致しません。CSVファイルを確認して、再試行してください。',
        alreadyAdd:'この2つのアカウントの組み合わせはすでに追加されています。',
        cleanAll:'選択した組み合わせをすべてクリーニングしようとしていますが、続行してもよろしいですか？',
        sure:'はい、続行してください',
        allTransferred:'転送したファイルをすべて1つのフォルダに保存します。',
        newTrans:'トラバーサル開始時に送信を開始します。',
        optionActivated:'このオプションを有効にすると、転送されたすべてのファイルはターゲットクラウドの1つのフォルダに保持されます。例えば、ソースディレクトリがGoogle Workspace\\simon@multcloud.comであり、ターゲットディレクトリがOneDrive for Business\\peter@multcloud.comであり、このオプションを有効にすると、Google Workspace\\simon@multcloud.comのすべてのファイルがOneDrive for Business\\peter@multcloud.com\\simon@multcloud.comに転送されます。',
        newTransTip: 'サポート対象のタスク：1. ソースはフォルダでなければならない 2. ソースはクラウドドライブであり、メールではない 3. 宛先は写真ベースのクラウドドライブではない',
        organizationMigration:'CSVをダウンロード',
        downloadCSV:'CSVをダウンロード',
        dontShow:'これを二度と見せないでください',
        notSelected:'Google Workspaceの共有ドライブは、チーム移行のターゲットクラウドとして選択できません。',
        batchMatch:'バッチマッチ',
        sourceCloud:'ソースクラウドを追加',
        targetCloud:'ターゲットクラウドを追加',
        subTaskLimit:'サブタスクの上限',
        freeUsers:'無料版では、チーム転送タスクに3組のサブタスクを作成できます。プレミアム版にアップグレードすると、チーム転送タスクに1000個のサブタスクを作成できます。',
        mostTeamTransfer:'チーム転送で3つのサブタスク',
        substasksMost:'チーム転送で1000個のサブタスク',
        mostTasks:'サブタスクの数は最大1000個まで可能です。',
        timePassed:'設定した時間が過ぎました。',
    },
    shareTransfers: {
        logoMsg: '<span class="sf-logo-first">MultCloud</span><span class="sf-logo-name">転送</span>',
        addFiles: 'クラウドからファイルを追加',
        trnsfering: '転送中…',
        sendingFile: '{num}ファイル送信中',
        sendingSize: '{num}/{all}',
        sendingTip: '転送リンクの作成中、しばらくお待ちください。',
        cancelTransfer: 'この転送をキャンセルしますか？',
        createdTransfer: '転送が作成されました！',
        createShare: '転送を作成',
        signTitleByTransfer: 'Multcloudにログインして続行',
        signupTitleByTransfer: 'Multcloudにサインアップして続行',
        transferTitle: 'タイトル',
        transferDescription: '説明',
        addFileTip: '{num}ファイルを追加：',
        titleErrMsg: 'タイトルの長さは128文字以内にする必要があります。',
        desErrMsg: '説明の長さは512文字以内にする必要があります。',
        folder: 'フォルダ',
    },
    summerSale: {
        titleTip: '夏が来る',
        titleTip2: '無制限のクラウド間データトラフィックを手に入れ、夏の思い出を甘い価格で楽に管理しましょう！',
        bottomTip: '～今シーズンのベストオファ～',
    },
    halloweenSale: {
        titleTip2: 'トリートだけ、トリックなし！無制限のクラウド間データトラフィックが最大70%でゲット！',
        bottomTip: 'お急げ！早い者勝ち！',
    },
    newYear: {
        payTxt: "新春セール",
        titleTip: '無制限のクラウド間データトラフィック70%割引で新年を迎えましょう！',
        bottomTip: 'お急げ！早い者勝ち！',
    },
    backToSchool: {
        titleTip2: '無制限のクラウド間データトラフィックを取得し、学校での思い出を手頃な価格で管理しましょう！',
        bottomTip: '～今シーズンのベストオファ～',
    },
    blackFriday: {
        titleTip: '無制限のクラウド間データトラフィックを70%オフでご利用いただけます。',
        bottomTip: 'お急げ！早い者勝ち！',
    },
    xmas: {
        titleTip: '今年のクリスマスでは、無制限のクラウド間データトラフィックを70%割引でお楽しみください！',
        bottomTip: 'お急げ！早い者勝ち！',
    },
    license: {
        codeTitle: 'ライセンスを入力',
        codeTipTitle: 'ライセンスコードを入力',
        codeTipText: 'ライセンスコードをお持ちの場合は、プレミアムサービスの有効化にご利用いただけます。',
        codeTipTextVip: 'ライセンスコードをお持ちの場合は、より高度なサービスへアップグレードできます。',
        codeFooter: 'ご質問がある場合は、お気軽にお問い合わせください：',
        showTitle: 'ライセンスコード',
        showTip: 'ライセンスコードは次の通りです：',
        codeSucTitle: 'プレミアムサービス有効化',
        codeSucTip: 'プレミアムサービスが有効化されました！',
    },
    filters: {
        taskList: {
            typeName: '種類',
            type: {
                all: 'すべてのリスト',
                copy: '一時タスク',
                transfer: 'クラウド転送',
                sync: 'クラウド同期',
                backup: 'クラウドバックアップ',
                business: 'チーム転送',
                remoteUpload: 'リモートアップロード',
                emailMigration: 'メール移行',
                restore: 'クラウド復元',
            },
            statusName: "ステータス",
            status: {
                all: "すべてのステータス",
                preset: 'プリセット',
                running: '実行中',
                success: '成功',
                patial: '部分成功',
                failed: '失敗',
                canceled: 'キャンセル済み',
            },
            dateName: "日付",
            date: {
                all: 'すべての期間',
                today: '今日',
                latestWeek: '過去1週間',
                latestMonth: '過去1ヶ月',
                customDate: 'カスタム日付',
            },
        }
    },
    schedule: {
        week1: "日",
        week2: "月",
        week3: "火",
        week4: "水",
        week5: "木",
        week6: "金",
        week7: "土",
    },
    inputTab: {
        filterMessage: 'Enterキーを押してファイルの拡張子を追加します。',
    }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/japanese.js